/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import logo from './logo.png';

const BASE = 'https://pushpamritwellness.org/api';
const api = async (ep, method = 'GET', body = null) => {
  const token = localStorage.getItem('pa_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = 'Bearer ' + token;
  const opts = { method, headers };
  if (body) opts.body = JSON.stringify(body);
  try {
    const res = await fetch(`${BASE}/${ep}`, opts);
    return await res.json();
  } catch (e) { return { status: 'error', message: 'Network error.' }; }
};

let _tt;
const toast = (msg, type = 'success') => {
  const el = document.getElementById('_toast');
  if (!el) return;
  el.textContent = msg;
  el.className = `_toast _toast-${type} _toast-show`;
  clearTimeout(_tt);
  _tt = setTimeout(() => { el.className = '_toast'; }, 3500);
};

const injectCSS = () => {
  if (document.getElementById('_pa_css')) return;
  const s = document.createElement('style');
  s.id = '_pa_css';
  s.textContent = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;600&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{
  --green:#2d6a4f;--green2:#52b788;--green3:#95d5b2;--green4:#d8f3dc;
  --gold:#c9a84c;--gold2:#e8cc7a;--gold3:#f5e6b8;
  --red:#c1121f;--orange:#e76f51;--blue:#2b7de9;
  --sidebar:#1b4332;--bg:#f4f9f5;--card:rgba(255,255,255,0.97);
  --border:rgba(45,106,79,0.12);--shadow:0 8px 32px rgba(27,67,50,0.12);
  --shadow2:0 2px 12px rgba(27,67,50,0.08);
  --r:14px;--r-sm:8px;--r-lg:20px;
  --font:'Inter',sans-serif;--font-h:'Playfair Display',serif;
  --text:#1a2e1a;--text2:#3d6b4d;--text3:#7a9e82;
}
body{background:var(--bg);color:var(--text);font-family:var(--font);font-size:14px;min-height:100vh;-webkit-font-smoothing:antialiased}
::-webkit-scrollbar{width:4px;height:4px}
::-webkit-scrollbar-thumb{background:var(--green3);border-radius:4px}
button,input,select,textarea{font-family:var(--font);outline:none}
.layout{display:flex;min-height:100vh}
.sidebar{width:260px;background:linear-gradient(180deg,#0d2b1e 0%,#1b4332 100%);height:100vh;position:fixed;left:0;top:0;display:flex;flex-direction:column;z-index:100;box-shadow:4px 0 30px rgba(0,0,0,0.25)}
.sidebar::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--gold),var(--gold2),var(--gold))}
.sb-logo{padding:20px 16px 14px;border-bottom:1px solid rgba(255,255,255,0.07);display:flex;align-items:center;gap:12px}
.sb-logo img{width:46px;height:46px;object-fit:contain;border-radius:10px;background:rgba(255,255,255,0.06);padding:3px}
.sb-name{color:#fff;font-family:var(--font-h);font-weight:700;font-size:13px;line-height:1.3}
.sb-sub{color:rgba(255,255,255,0.3);font-size:10px;text-transform:uppercase;letter-spacing:1.5px;margin-top:3px}
.sb-badge{margin:10px 14px;background:linear-gradient(135deg,var(--gold),var(--gold2));border-radius:20px;padding:5px 14px;color:#1a2e1a;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:1px;text-align:center}
.sb-nav{flex:1;padding:8px 10px;overflow-y:auto}
.nav-item{display:flex;align-items:center;gap:10px;padding:11px 13px;border-radius:var(--r-sm);background:transparent;color:rgba(255,255,255,0.45);font-size:13px;font-weight:500;width:100%;text-align:left;transition:all .2s;margin-bottom:2px;border:none;cursor:pointer}
.nav-item:hover{background:rgba(255,255,255,0.07);color:rgba(255,255,255,0.8)}
.nav-item.active{background:rgba(201,168,76,0.15);color:var(--gold2);border:1px solid rgba(201,168,76,0.2);font-weight:600}
.nav-icon{font-size:16px;width:22px;text-align:center;flex-shrink:0}
.nav-badge{margin-left:auto;background:var(--red);color:#fff;border-radius:10px;padding:2px 7px;font-size:10px;font-weight:700}
.sb-footer{padding:14px;border-top:1px solid rgba(255,255,255,0.07)}
.sb-user{display:flex;align-items:center;gap:10px;padding:10px 12px;background:rgba(255,255,255,0.05);border-radius:var(--r-sm);margin-bottom:10px}
.sb-av{width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,var(--gold),var(--gold2));color:#1a2e1a;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:15px;flex-shrink:0}
.sb-un{color:#fff;font-size:13px;font-weight:600}
.sb-ur{color:rgba(255,255,255,0.3);font-size:10px;margin-top:1px;text-transform:capitalize}
.logout-btn{width:100%;padding:9px;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.08);border-radius:var(--r-sm);color:rgba(255,255,255,0.4);font-size:12px;font-weight:600;transition:all .2s;cursor:pointer}
.logout-btn:hover{background:rgba(193,18,31,0.2);border-color:rgba(193,18,31,0.4);color:#fff}
.main{margin-left:260px;flex:1;display:flex;flex-direction:column;min-height:100vh}
.topbar{background:var(--card);border-bottom:1px solid var(--border);padding:14px 28px;display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;z-index:50;box-shadow:var(--shadow2)}
.topbar-title{font-family:var(--font-h);font-size:20px;font-weight:700;color:var(--green)}
.topbar-sub{color:var(--text3);font-size:12px;margin-top:2px}
.topbar-right{display:flex;align-items:center;gap:10px}
.page{padding:24px 28px;flex:1}
.card{background:var(--card);border:1px solid var(--border);border-radius:var(--r);padding:22px;margin-bottom:20px;box-shadow:var(--shadow2)}
.card-title{font-family:var(--font-h);font-size:15px;font-weight:700;color:var(--text);margin-bottom:18px;display:flex;align-items:center;gap:8px;padding-bottom:12px;border-bottom:1px solid var(--border)}
.ct-icon{width:32px;height:32px;border-radius:8px;background:linear-gradient(135deg,var(--green),var(--green2));display:flex;align-items:center;justify-content:center;color:#fff;font-size:15px;flex-shrink:0}
.stat-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:14px;margin-bottom:20px}
.stat-grid-4{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;margin-bottom:20px}
.stat-grid-3{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;margin-bottom:20px}
.stat-card{background:var(--card);border:1px solid var(--border);border-radius:var(--r);padding:18px;position:relative;overflow:hidden;transition:all .2s}
.stat-card::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:var(--ac,linear-gradient(90deg,var(--green),var(--green2)))}
.stat-card:hover{transform:translateY(-2px);box-shadow:var(--shadow)}
.stat-icon{width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:19px;margin-bottom:12px}
.stat-val{font-family:var(--font-h);font-size:28px;font-weight:700;color:var(--text);line-height:1;margin-bottom:4px}
.stat-label{color:var(--text3);font-size:11px;font-weight:500;text-transform:uppercase;letter-spacing:.5px}
.g2{display:grid;grid-template-columns:1fr 1fr;gap:20px}
.field{margin-bottom:16px}
.flabel{display:block;color:var(--text2);font-size:11px;font-weight:700;margin-bottom:6px;text-transform:uppercase;letter-spacing:.5px}
.inp{width:100%;background:rgba(45,106,79,0.04);border:1.5px solid var(--border);border-radius:var(--r-sm);padding:10px 13px;color:var(--text);font-size:13px;transition:all .2s}
.inp:focus{border-color:var(--green);box-shadow:0 0 0 3px rgba(45,106,79,0.1)}
.sel{width:100%;background:rgba(45,106,79,0.04);border:1.5px solid var(--border);border-radius:var(--r-sm);padding:10px 13px;color:var(--text);font-size:13px;transition:all .2s;cursor:pointer}
.sel:focus{border-color:var(--green)}
.ta{width:100%;background:rgba(45,106,79,0.04);border:1.5px solid var(--border);border-radius:var(--r-sm);padding:10px 13px;color:var(--text);font-size:13px;resize:vertical;min-height:80px;transition:all .2s}
.ta:focus{border-color:var(--green)}
.btn{border:none;border-radius:var(--r-sm);padding:10px 20px;font-size:13px;font-weight:600;display:inline-flex;align-items:center;justify-content:center;gap:7px;transition:all .2s;white-space:nowrap;cursor:pointer}
.btn:disabled{opacity:.4;cursor:not-allowed}
.btn-full{width:100%;padding:12px 20px}
.btn-sm{padding:7px 13px;font-size:12px;border-radius:6px}
.btn-green{background:linear-gradient(135deg,var(--green),var(--green2));color:#fff;box-shadow:0 4px 14px rgba(45,106,79,0.25)}
.btn-green:not(:disabled):hover{box-shadow:0 6px 20px rgba(45,106,79,0.4);transform:translateY(-1px)}
.btn-gold{background:linear-gradient(135deg,var(--gold),var(--gold2));color:#1a2e1a;box-shadow:0 4px 14px rgba(201,168,76,0.25)}
.btn-gold:not(:disabled):hover{box-shadow:0 6px 20px rgba(201,168,76,0.4);transform:translateY(-1px)}
.btn-red{background:linear-gradient(135deg,#c1121f,#e63946);color:#fff}
.btn-red:not(:disabled):hover{transform:translateY(-1px)}
.btn-ghost{background:rgba(45,106,79,0.06);border:1.5px solid var(--border);color:var(--text2)}
.btn-ghost:not(:disabled):hover{border-color:var(--green);color:var(--green)}
.btn-blue{background:linear-gradient(135deg,#2b7de9,#1a5ec4);color:#fff}
.btn-orange{background:linear-gradient(135deg,var(--orange),#f4a261);color:#fff}
.badge{display:inline-flex;align-items:center;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:600}
.bg-green{background:rgba(45,106,79,0.12);color:var(--green)}
.bg-gold{background:rgba(201,168,76,0.15);color:#8a6d00}
.bg-red{background:rgba(193,18,31,0.1);color:var(--red)}
.bg-blue{background:rgba(43,125,233,0.1);color:var(--blue)}
.bg-gray{background:rgba(0,0,0,0.07);color:var(--text3)}
.bg-orange{background:rgba(231,111,81,0.1);color:var(--orange)}
.tbl{width:100%;border-collapse:collapse}
.tbl th{color:var(--text3);font-size:11px;font-weight:700;text-align:left;padding:10px 14px;border-bottom:2px solid var(--border);text-transform:uppercase;letter-spacing:.5px}
.tbl td{padding:12px 14px;border-bottom:1px solid var(--border);font-size:13px;vertical-align:middle}
.tbl tr:last-child td{border-bottom:none}
.tbl tr:hover td{background:rgba(45,106,79,0.02)}
.tbl-green td{background:rgba(45,106,79,0.05)!important}
.tbl-yellow td{background:rgba(201,168,76,0.07)!important}
.tbl-red td{background:rgba(193,18,31,0.04)!important}
.tabs{display:flex;gap:3px;background:rgba(45,106,79,0.07);padding:4px;border-radius:var(--r);margin-bottom:20px}
.tab{flex:1;padding:9px 16px;border-radius:var(--r-sm);background:transparent;color:var(--text3);font-size:13px;font-weight:600;transition:all .2s;border:none;cursor:pointer}
.tab.active{background:var(--card);color:var(--text);box-shadow:var(--shadow2)}
.modal-bg{display:none;position:fixed;inset:0;background:rgba(0,0,0,0.5);backdrop-filter:blur(6px);z-index:1000;align-items:center;justify-content:center}
.modal-bg.open{display:flex}
.modal{background:var(--card);border:1px solid var(--border);border-radius:var(--r-lg);padding:28px;width:520px;max-width:95vw;max-height:92vh;overflow-y:auto;box-shadow:var(--shadow)}
.modal-title{font-family:var(--font-h);font-size:18px;font-weight:700;margin-bottom:22px;padding-bottom:14px;border-bottom:1px solid var(--border)}
._toast{position:fixed;bottom:24px;right:24px;padding:14px 22px;border-radius:var(--r);font-size:13px;font-weight:600;z-index:9999;opacity:0;transform:translateY(10px);transition:all .3s;pointer-events:none;max-width:350px;box-shadow:var(--shadow)}
._toast-show{opacity:1;transform:translateY(0)}
._toast-success{background:linear-gradient(135deg,var(--green),var(--green2));color:#fff}
._toast-error{background:linear-gradient(135deg,#c1121f,#e63946);color:#fff}
._toast-info{background:linear-gradient(135deg,var(--blue),#1a5ec4);color:#fff}
._toast-warning{background:linear-gradient(135deg,var(--gold),var(--gold2));color:#1a2e1a}
.prog-wrap{background:rgba(45,106,79,0.1);border-radius:8px;height:10px;overflow:hidden}
.prog-bar{height:100%;border-radius:8px;transition:width .6s ease}
.lead-hero{background:linear-gradient(135deg,#1b4332 0%,#2d6a4f 60%,#1b4332 100%);border-radius:var(--r-lg);padding:26px;color:#fff;margin-bottom:20px;position:relative;overflow:hidden;box-shadow:0 10px 40px rgba(27,67,50,0.4)}
.lead-phone{font-family:var(--font-h);font-size:32px;font-weight:700;letter-spacing:2px;margin:10px 0 6px;color:var(--gold2)}
.lead-pending-badge{position:absolute;top:22px;right:22px;background:rgba(201,168,76,0.2);border:1px solid rgba(201,168,76,0.4);border-radius:20px;padding:5px 14px;font-size:12px;font-weight:700;color:var(--gold2)}
.disp-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-bottom:18px}
.disp-btn{padding:12px 8px;border-radius:var(--r-sm);border:1.5px solid var(--border);background:rgba(45,106,79,0.03);color:var(--text2);font-size:12px;font-weight:600;text-align:center;transition:all .2s;cursor:pointer}
.disp-btn:hover{border-color:var(--green);color:var(--green)}
.disp-sel{border-color:var(--green)!important;background:rgba(45,106,79,0.12)!important;color:var(--green)!important}
.disp-sel-gold{border-color:var(--gold)!important;background:rgba(201,168,76,0.12)!important;color:#8a6d00!important}
.att-btn{padding:8px 16px;border-radius:6px;font-size:12px;font-weight:700;border:1.5px solid;cursor:pointer;transition:all .2s}
.att-present{background:rgba(45,106,79,0.1);border-color:var(--green);color:var(--green)}
.att-present.att-active{background:var(--green);color:#fff}
.att-absent{background:rgba(193,18,31,0.1);border-color:var(--red);color:var(--red)}
.att-absent.att-active{background:var(--red);color:#fff}
.dot{width:8px;height:8px;border-radius:50%;display:inline-block;flex-shrink:0}
.dot-green{background:var(--green)}.dot-yellow{background:#e9c46a}.dot-red{background:var(--red)}.dot-gray{background:var(--text3)}
.center-spin{display:flex;align-items:center;justify-content:center;padding:60px}
.spin{width:30px;height:30px;border:3px solid var(--green3);border-top-color:var(--green);border-radius:50%;animation:_spin .7s linear infinite;display:inline-block}
@keyframes _spin{to{transform:rotate(360deg)}}
.empty{text-align:center;padding:48px 20px;color:var(--text3)}
.fu-card{padding:14px 18px;border-radius:var(--r);border:1.5px solid var(--border);margin-bottom:10px;background:var(--card)}
.fu-card.overdue{border-color:var(--red);background:rgba(193,18,31,0.03)}
.fu-card.soon{border-color:var(--gold);background:rgba(201,168,76,0.04)}
.msg-item{padding:14px 18px;border-radius:var(--r);margin-bottom:8px;border:1px solid var(--border);background:var(--card)}
.msg-item.unread{border-color:var(--green);background:rgba(45,106,79,0.04)}
.accordion-item{border:1px solid var(--border);border-radius:var(--r);margin-bottom:10px;overflow:hidden}
.accordion-hd{padding:14px 18px;background:var(--card);display:flex;align-items:center;gap:12px;cursor:pointer}
.accordion-bd{padding:0 18px 14px;background:rgba(45,106,79,0.02)}
.lead-list-item{padding:10px 12px;border-radius:var(--r-sm);border:1.5px solid var(--border);margin-bottom:6px;cursor:pointer;transition:all .15s}
.lead-list-item:hover{border-color:var(--green2)}
.lead-list-item.sel{border-color:var(--green);background:rgba(45,106,79,0.08)}
.hist-item{display:flex;gap:12px;padding:10px 0;border-bottom:1px solid var(--border);align-items:flex-start}
.hist-item:last-child{border-bottom:none}
.hist-time{color:var(--text3);font-size:11px;min-width:130px;padding-top:2px;font-family:'JetBrains Mono',monospace}
.lb-row{display:flex;align-items:center;gap:14px;padding:14px 18px;border-radius:var(--r);margin-bottom:8px;background:var(--card);border:1px solid var(--border)}
.lb-me{background:rgba(45,106,79,0.06);border-color:var(--green)}
.pass-wrap{position:relative}
.pass-wrap .inp{padding-right:44px}
.pass-eye{position:absolute;right:12px;top:50%;transform:translateY(-50%);background:none;border:none;color:var(--text3);cursor:pointer;font-size:16px;padding:4px}
.notif-bell{position:relative;cursor:pointer;width:38px;height:38px;border-radius:var(--r-sm);background:var(--card);border:1px solid var(--border);display:flex;align-items:center;justify-content:center;color:var(--text2)}
.notif-dot{position:absolute;top:6px;right:6px;width:8px;height:8px;border-radius:50%;background:var(--red);border:2px solid var(--bg)}
.login-wrap{min-height:100vh;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#0d2b1e 0%,#1b4332 50%,#0d2b1e 100%)}
.login-card{background:rgba(255,255,255,0.04);backdrop-filter:blur(30px);border:1px solid rgba(201,168,76,0.2);border-radius:24px;padding:44px;width:420px;max-width:95vw;box-shadow:0 20px 60px rgba(0,0,0,0.4)}
.login-inp{width:100%;background:rgba(255,255,255,0.07);border:1.5px solid rgba(255,255,255,0.12);border-radius:var(--r-sm);padding:12px 14px;color:#fff;font-size:14px;transition:all .2s}
.login-inp:focus{border-color:var(--gold);box-shadow:0 0 0 3px rgba(201,168,76,0.15)}
.login-inp::placeholder{color:rgba(255,255,255,0.3)}
.search-bar{display:flex;align-items:center;gap:10px;background:var(--card);border:1.5px solid var(--border);border-radius:var(--r);padding:10px 16px}
.search-bar input{flex:1;border:none;background:transparent;color:var(--text);font-size:14px}
.search-bar:focus-within{border-color:var(--green)}
`;
  document.head.appendChild(s);
};

// ─── UI COMPONENTS ────────────────────────────────────────────────────────
const Spin = () => <div className="center-spin"><div className="spin"/></div>;
const Empty = ({ title='No data', desc='' }) => (
  <div className="empty">
    <div style={{fontSize:44,opacity:.4,marginBottom:14}}>🌿</div>
    <div style={{fontSize:15,fontWeight:600,marginBottom:6}}>{title}</div>
    {desc && <div style={{fontSize:13}}>{desc}</div>}
  </div>
);
const Badge = ({ color='gray', children, style={} }) => (
  <span className={`badge bg-${color}`} style={style}>{children}</span>
);
const Btn = ({ children, color='green', onClick, disabled, full, size, style={} }) => (
  <button onClick={onClick} disabled={disabled} style={style}
    className={`btn btn-${color}${full?' btn-full':''}${size==='sm'?' btn-sm':''}`}>
    {children}
  </button>
);
const Field = ({ label, children }) => (
  <div className="field">{label && <label className="flabel">{label}</label>}{children}</div>
);
const Inp = ({ label, ...p }) => <Field label={label}><input className="inp" {...p}/></Field>;
const Sel = ({ label, children, ...p }) => (
  <Field label={label}><select className="sel" {...p}>{children}</select></Field>
);
const TA = ({ label, ...p }) => <Field label={label}><textarea className="ta" {...p}/></Field>;
const Card = ({ children, style }) => <div className="card" style={style}>{children}</div>;
const CT = ({ icon, children }) => (
  <div className="card-title">
    {icon && <div className="ct-icon">{icon}</div>}
    {children}
  </div>
);
const StatCard = ({ val, label, icon, bg, ac }) => (
  <div className="stat-card" style={{'--ac':ac}}>
    <div className="stat-icon" style={{background:bg||'rgba(45,106,79,0.1)'}}>{icon}</div>
    <div className="stat-val">{val}</div>
    <div className="stat-label">{label}</div>
  </div>
);
const PasswordInput = ({ label, value, onChange, placeholder }) => {
  const [show, setShow] = useState(false);
  return (
    <Field label={label}>
      <div className="pass-wrap">
        <input className="inp" type={show?'text':'password'} value={value} onChange={onChange} placeholder={placeholder||'••••••••'}/>
        <button type="button" className="pass-eye" onClick={()=>setShow(s=>!s)}>{show?'🙈':'👁️'}</button>
      </div>
    </Field>
  );
};

// ─── NAV CONFIG ────────────────────────────────────────────────────────────
const ICONS={dashboard:'📊',data:'📋',assign:'🎯',accounts:'👥',attendance:'✅',products:'📦',blacklist:'🚫',reports:'📈',settings:'⚙️',calling:'📞',punch:'📝',followups:'📅',myleads:'📂',performance:'🏆',leaderboard:'🥇',messages:'💬',search:'🔍',profile:'👤',team:'👁️',callers:'👤',report:'📊'};
const NAV={
  admin:[{id:'dashboard',label:'Dashboard'},{id:'data',label:'Data Management'},{id:'assign',label:'Assignment'},{id:'accounts',label:'Accounts'},{id:'attendance',label:'Attendance'},{id:'products',label:'Products'},{id:'blacklist',label:'Blacklist'},{id:'reports',label:'Reports'},{id:'settings',label:'Settings'}],
  tl:[{id:'dashboard',label:'Dashboard'},{id:'data',label:'My Data'},{id:'assign',label:'Assign Leads'},{id:'attendance',label:'Attendance'},{id:'team',label:'Team Monitor'},{id:'followups',label:'Follow Ups'},{id:'report',label:'Reports'},{id:'messages',label:'Messages'},{id:'callers',label:'My Callers'},{id:'search',label:'Search Lead'}],
  caller:[{id:'calling',label:'Calling'},{id:'punch',label:'My Punches'},{id:'followups',label:'Follow Ups'},{id:'myleads',label:'My Leads'},{id:'performance',label:'Performance'},{id:'leaderboard',label:'Leaderboard'},{id:'messages',label:'Messages'},{id:'search',label:'Search Lead'},{id:'profile',label:'Profile'}]
};
const PAGE_TITLE={dashboard:'Dashboard',data:'Data Management',assign:'Assignment',accounts:'Accounts',attendance:'Attendance',products:'Products',blacklist:'Blacklist',reports:'Reports',settings:'Settings',calling:'Calling Screen',punch:'My Punches',followups:'Follow Ups',myleads:'My Leads',performance:'Performance',leaderboard:'Leaderboard',messages:'Messages',search:'Search Lead',profile:'Profile',team:'Team Monitor',report:'Reports',callers:'My Callers'};

// ─── LOGIN ─────────────────────────────────────────────────────────────────
function LoginPage({ onLogin }) {
  const [email,setEmail]=useState('');
  const [pass,setPass]=useState('');
  const [showPass,setShowPass]=useState(false);
  const [err,setErr]=useState('');
  const [loading,setLoading]=useState(false);
  const doLogin=async()=>{
    if(!email||!pass)return setErr('Email and password are required.');
    setLoading(true);setErr('');
    const r=await api('auth.php?action=login','POST',{email,password:pass});
    if(r.status==='success'){localStorage.setItem('pa_token',r.data.token);onLogin(r.data.user);}
    else setErr(r.message||'Login failed.');
    setLoading(false);
  };
  return(
    <div className="login-wrap">
      <div className="login-card">
        <div style={{textAlign:'center',marginBottom:32}}>
          <img src={logo} alt="PushpAmrit" style={{height:80,objectFit:'contain',marginBottom:16}}/>
          <h2 style={{fontFamily:'Playfair Display,serif',fontSize:22,fontWeight:700,color:'#fff',marginBottom:6}}>Welcome Back</h2>
          <p style={{color:'rgba(255,255,255,0.35)',fontSize:13}}>PushpAmrit Wellness — CRM Login</p>
        </div>
        <div className="field">
          <label className="flabel" style={{color:'rgba(255,255,255,0.5)'}}>Email Address</label>
          <input className="login-inp" type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="your@email.com" onKeyDown={e=>e.key==='Enter'&&doLogin()}/>
        </div>
        <div className="field">
          <label className="flabel" style={{color:'rgba(255,255,255,0.5)'}}>Password</label>
          <div className="pass-wrap">
            <input className="login-inp" type={showPass?'text':'password'} value={pass} onChange={e=>setPass(e.target.value)} placeholder="Enter your password" onKeyDown={e=>e.key==='Enter'&&doLogin()} style={{paddingRight:44}}/>
            <button type="button" className="pass-eye" style={{color:'rgba(255,255,255,0.4)'}} onClick={()=>setShowPass(s=>!s)}>{showPass?'🙈':'👁️'}</button>
          </div>
        </div>
        {err&&<div style={{background:'rgba(193,18,31,0.15)',border:'1px solid rgba(193,18,31,0.3)',borderRadius:8,padding:'10px 14px',color:'#e63946',fontSize:13,marginBottom:16}}>⚠️ {err}</div>}
        <button onClick={doLogin} disabled={loading} className="btn btn-gold btn-full" style={{fontSize:15,padding:'13px 20px',marginTop:4}}>
          {loading?'Signing in...':'Sign In →'}
        </button>
        <p style={{textAlign:'center',color:'rgba(255,255,255,0.2)',fontSize:11,marginTop:24}}>PushpAmrit Wellness CRM v1.0</p>
      </div>
    </div>
  );
}

// ─── SIDEBAR ───────────────────────────────────────────────────────────────
function Sidebar({ user, page, onNav, onLogout, notifCount }) {
  const items=NAV[user.role]||[];
  return(
    <div className="sidebar">
      <div className="sb-logo">
        <img src={logo} alt="PA"/>
        <div><div className="sb-name">PushpAmrit Wellness</div><div className="sb-sub">Telecalling CRM</div></div>
      </div>
      <div className="sb-badge">{user.role} Panel</div>
      <nav className="sb-nav">
        {items.map(item=>(
          <button key={item.id} className={`nav-item${page===item.id?' active':''}`} onClick={()=>onNav(item.id)}>
            <span className="nav-icon">{ICONS[item.id]||'•'}</span>
            <span style={{flex:1}}>{item.label}</span>
            {item.id==='messages'&&notifCount>0&&<span className="nav-badge">{notifCount}</span>}
          </button>
        ))}
      </nav>
      <div className="sb-footer">
        <div className="sb-user">
          <div className="sb-av">{user.name[0].toUpperCase()}</div>
          <div><div className="sb-un">{user.name}</div><div className="sb-ur">{user.role}</div></div>
        </div>
        <button className="logout-btn" onClick={onLogout}>🚪 Logout</button>
      </div>
    </div>
  );
}

// ─── TOPBAR FLASH ──────────────────────────────────────────────────────────
function TopPerformerFlash() {
  const [top,setTop]=useState(null);
  const [fl,setFl]=useState(false);
  useEffect(()=>{
    const ch=async()=>{const r=await api('reports.php?action=top_performer');if(r.status==='success'&&r.data.today_conv>0)setTop(r.data);else setTop(null);};
    ch();const t=setInterval(ch,60000);return()=>clearInterval(t);
  },[]);
  useEffect(()=>{if(!top)return;const t=setInterval(()=>setFl(f=>!f),1000);return()=>clearInterval(t);},[top]);
  if(!top||top.today_conv===0)return null;
  return(
    <div style={{background:fl?'rgba(201,168,76,0.18)':'transparent',border:'1px solid var(--gold)',borderRadius:8,padding:'5px 12px',display:'flex',alignItems:'center',gap:6,transition:'background .5s'}}>
      <span>🏆</span><span style={{fontSize:12,fontWeight:700,color:'var(--gold)'}}>{top.name}: {top.today_conv} today!</span>
    </div>
  );
}

function FUFlasher({ onNav }) {
  const [urgent,setUrgent]=useState([]);
  const [fl,setFl]=useState(false);
  useEffect(()=>{
    const ch=async()=>{const r=await api('leads.php?action=followups');if(r.status==='success'){const now=new Date();setUrgent(r.data.filter(l=>{if(!l.followup_at)return false;const d=(new Date(l.followup_at)-now)/60000;return d<=5&&d>=-30;}));}};
    ch();const t=setInterval(ch,30000);return()=>clearInterval(t);
  },[]);
  useEffect(()=>{if(urgent.length>0){const t=setInterval(()=>setFl(f=>!f),800);return()=>clearInterval(t);}setFl(false);},[urgent]);
  if(!urgent.length)return null;
  return(
    <div onClick={()=>onNav('followups')} style={{cursor:'pointer',background:fl?'var(--red)':'rgba(193,18,31,0.1)',border:'2px solid var(--red)',borderRadius:8,padding:'6px 14px',display:'flex',alignItems:'center',gap:8,transition:'background .3s'}}>
      <span>📅</span><span style={{fontWeight:700,fontSize:13,color:fl?'#fff':'var(--red)'}}>{urgent.length} Follow Up{urgent.length>1?'s':''} Due!</span>
    </div>
  );
}

// ─── ADMIN DASHBOARD ──────────────────────────────────────────────────────
function AdminDashboard() {
  const [data,setData]=useState(null);
  const load=useCallback(async()=>{const r=await api('reports.php?action=analytics');if(r.status==='success')setData(r.data);},[]);
  useEffect(()=>{load();const t=setInterval(load,30000);return()=>clearInterval(t);},[load]);
  if(!data)return<Spin/>;
  const o=data.overall||{};
  return(
    <>
      <div className="stat-grid">
        <StatCard val={o.total_leads||0} label="Total Leads" icon="📋" bg="rgba(43,125,233,0.1)" ac="linear-gradient(90deg,#2b7de9,#64a8f0)"/>
        <StatCard val={o.fresh||0} label="Fresh Total" icon="🌱" bg="rgba(45,106,79,0.1)" ac="linear-gradient(90deg,var(--green),var(--green2))"/>
        <StatCard val={(o.fresh||0)-(o.fresh_unassigned||0)} label="Fresh Assigned" icon="✔️" bg="rgba(82,183,136,0.12)" ac="linear-gradient(90deg,var(--green2),var(--green3))"/>
        <StatCard val={o.fresh_unassigned||0} label="Fresh Remaining" icon="⭕" bg="rgba(201,168,76,0.1)" ac="linear-gradient(90deg,var(--gold),var(--gold2))"/>
        <StatCard val={o.converted||0} label="Converted" icon="✅" bg="rgba(45,106,79,0.15)" ac="linear-gradient(90deg,var(--green),var(--green2))"/>
      </div>
      <div className="g2">
        <Card>
          <CT icon="📦">Product Performance</CT>
          {(data.product_wise||[]).map(p=>(
            <div key={p.name} style={{marginBottom:16}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:6}}>
                <span style={{fontWeight:600}}>{p.name}</span>
                <span style={{color:'var(--green)',fontWeight:700}}>{p.converted}/{p.total} ({p.rate||0}%)</span>
              </div>
              <div className="prog-wrap"><div className="prog-bar" style={{width:`${p.rate||0}%`,background:'linear-gradient(90deg,var(--green),var(--green2))'}}/></div>
            </div>
          ))}
          {!(data.product_wise?.length)&&<Empty title="No product data yet"/>}
        </Card>
        <Card>
          <CT icon="🏆">Top Callers Today</CT>
          {(data.top_callers||[]).map((c,i)=>(
            <div key={c.name} style={{display:'flex',alignItems:'center',gap:12,padding:'11px 0',borderBottom:'1px solid var(--border)'}}>
              <span style={{fontSize:22,width:32}}>{['🥇','🥈','🥉','4️⃣','5️⃣'][i]}</span>
              <span style={{flex:1,fontWeight:600}}>{c.name}</span>
              <span style={{fontSize:22,fontWeight:800,color:'var(--green)',fontFamily:'Playfair Display,serif'}}>{c.converted}</span>
            </div>
          ))}
          {!(data.top_callers?.length)&&<Empty title="No data today"/>}
        </Card>
      </div>
      <Card>
        <CT icon="👔">TL Overview</CT>
        {(data.tl_stats||[]).length?(
          <table className="tbl">
            <thead><tr><th>TL Name</th><th>Total Leads</th><th>Converted</th><th>Team Size</th></tr></thead>
            <tbody>{data.tl_stats.map(t=>(
              <tr key={t.id}>
                <td style={{fontWeight:600}}>{t.name}</td>
                <td>{t.total_leads}</td>
                <td style={{color:'var(--green)',fontWeight:700,fontSize:16}}>{t.converted}</td>
                <td>{t.callers} callers</td>
              </tr>
            ))}</tbody>
          </table>
        ):<Empty title="No TLs yet"/>}
      </Card>
    </>
  );
}

// ─── DATA MANAGEMENT ──────────────────────────────────────────────────────
function DataManagement({ user, products }) {
  const [pool,setPool]=useState('fresh');
  const [productId,setProductId]=useState('');
  const [search,setSearch]=useState('');
  const [leads,setLeads]=useState([]);
  const [total,setTotal]=useState(0);
  const [loading,setLoading]=useState(false);
  const [page,setPage]=useState(1);
  const [pasteData,setPasteData]=useState('');
  const [uploadResult,setUploadResult]=useState(null);
  const [uploading,setUploading]=useState(false);
  const [showUpload,setShowUpload]=useState(false);
  const [uploadType,setUploadType]=useState('fresh');
  const [selectedIds,setSelectedIds]=useState([]);
  const [assignUser,setAssignUser]=useState('');
  const [users,setUsers]=useState([]);
  const [histModal,setHistModal]=useState(null);
  const [history,setHistory]=useState([]);
  const [showRollConfirm,setShowRollConfirm]=useState(false);
  const [recentDays,setRecentDays]=useState(()=>parseInt(localStorage.getItem('pa_rd')||'7'));

  const load=useCallback(async()=>{
    setLoading(true);
    const p=new URLSearchParams({pool,page,limit:50});
    if(productId)p.append('product_id',productId);
    if(search)p.append('search',search);
    const r=await api(`leads.php?action=list&${p}`);
    if(r.status==='success'){setLeads(r.data.leads||[]);setTotal(r.data.total||0);}
    setLoading(false);
  },[pool,productId,search,page]);

  useEffect(()=>{load();},[load]);
  useEffect(()=>{
    if(user.role==='admin')api('users.php?action=list&role=tl').then(r=>{if(r.status==='success')setUsers(r.data);});
    else api('users.php?action=list').then(r=>{if(r.status==='success')setUsers(r.data.filter(u=>u.role==='caller'&&String(u.tl_id)===String(user.id)));});
  },[user]);

  const handleFile=e=>{const f=e.target.files[0];if(!f)return;const reader=new FileReader();reader.onload=ev=>setPasteData(ev.target.result);reader.readAsText(f);};

  const doUpload=async(utype='fresh')=>{
    if(!productId)return toast('Select a product','error');
    if(!pasteData.trim())return toast('Paste data first','error');
    const rows=pasteData.trim().split('\n').map(line=>{const parts=line.split(/[,\t]/);return parts.length>=2?{name:parts[0].trim(),phone:parts[1].trim()}:{name:'',phone:parts[0].trim()};}).filter(r=>r.phone&&r.phone.replace(/\D/,'').length>=10);
    if(!rows.length)return toast('No valid numbers found','error');
    setUploading(true);
    const r=await api('leads.php?action=upload','POST',{product_id:productId,leads:rows,pool:utype});
    if(r.status==='success'){setUploadResult(r.data);toast(`${r.data.imported} leads uploaded!`);if(r.data.conflicts?.length>0)toast(`⚠️ ${r.data.conflicts.length} numbers already assigned`,'warning');load();}
    else toast(r.message,'error');
    setUploading(false);
  };

  const toggleSel=(id,idx,e)=>{
    if(e.shiftKey&&selectedIds.length>0){
      const allIds=leads.map(l=>l.id);
      const last=leads.findIndex(l=>l.id===selectedIds[selectedIds.length-1]);
      const start=Math.min(last,idx);const end=Math.max(last,idx);
      setSelectedIds(prev=>[...new Set([...prev,...allIds.slice(start,end+1)])]);
    }else setSelectedIds(prev=>prev.includes(id)?prev.filter(x=>x!==id):[...prev,id]);
  };

  const assignSelected=async()=>{
    if(!assignUser||!selectedIds.length)return toast('Select leads and a user','error');
    const r=await api('leads.php?action=assign_manual','POST',{lead_ids:selectedIds,to_id:assignUser});
    if(r.status==='success'){toast(`${r.data.assigned} leads assigned!`);setSelectedIds([]);load();}
    else toast(r.message,'error');
  };

  const viewHist=async lid=>{setHistModal(lid);const r=await api(`leads.php?action=history&lead_id=${lid}`);if(r.status==='success')setHistory(r.data);};
  const pools=user.role==='admin'?['fresh','recent','assigned','converted']:['all','fresh','recent','followup','converted'];

  return(
    <>
      {user.role==='admin'&&(
        <div style={{marginBottom:16,display:'flex',justifyContent:'flex-end'}}><Btn color="green" onClick={()=>setShowUpload(!showUpload)}>📤 Upload Data</Btn></div>
      )}
      {user.role==='tl'&&(
        <div style={{marginBottom:16,display:'flex',justifyContent:'flex-end',gap:10,alignItems:'center'}}>
          <div style={{display:'flex',alignItems:'center',gap:8,background:'var(--card)',border:'1px solid var(--border)',borderRadius:'var(--r-sm)',padding:'8px 12px'}}>
            <span style={{fontSize:12,color:'var(--text2)',fontWeight:600}}>Recent Range:</span>
            <select className="sel" value={recentDays} onChange={e=>{const v=parseInt(e.target.value);setRecentDays(v);localStorage.setItem('pa_rd',v);}} style={{width:130,padding:'5px 10px',fontSize:12}}>
              <option value="3">Last 3 days</option><option value="7">Last 7 days</option>
              <option value="15">Last 15 days</option><option value="30">Last 30 days</option><option value="0">All time</option>
            </select>
          </div>
          <Btn color="gold" onClick={()=>setShowRollConfirm(true)}>🔄 Roll Recent Data</Btn>
        </div>
      )}

      {showUpload&&user.role==='admin'&&(
        <Card>
          <div style={{display:'flex',gap:8,marginBottom:16}}>
            <button className={`btn btn-sm ${uploadType==='fresh'?'btn-green':'btn-ghost'}`} onClick={()=>setUploadType('fresh')}>🌱 Fresh Data</button>
            <button className={`btn btn-sm ${uploadType==='recent'?'btn-gold':'btn-ghost'}`} onClick={()=>setUploadType('recent')}>🔄 Recent Data</button>
          </div>
          <CT icon="📤">Upload {uploadType==='fresh'?'Fresh':'Recent'} Data</CT>
          <div className="g2">
            <div>
              <Sel label="Product" value={productId} onChange={e=>setProductId(e.target.value)}>
                <option value="">-- Select Product --</option>
                {products.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
              </Sel>
              <Field label="CSV File"><input type="file" accept=".csv,.txt" onChange={handleFile} style={{color:'var(--text2)',fontSize:13}}/></Field>
              <Btn color={uploadType==='fresh'?'green':'gold'} full onClick={()=>doUpload(uploadType)} disabled={uploading}>{uploading?'Uploading...':'Upload'}</Btn>
            </div>
            <TA label="Or Paste Data (Name, Phone per line)" value={pasteData} onChange={e=>setPasteData(e.target.value)} rows={8} placeholder={"Ramesh Kumar, 9876543210\nPriya Sharma, 9876543211"}/>
          </div>
          {uploadResult&&(
            <>
              <div className="stat-grid-3" style={{marginTop:16}}>
                <StatCard val={uploadResult.imported} label="Imported" icon="✅" bg="rgba(45,106,79,0.1)"/>
                <StatCard val={uploadResult.duplicates} label="Duplicates" icon="⚠️" bg="rgba(201,168,76,0.1)"/>
                <StatCard val={uploadResult.blacklisted} label="Blacklisted" icon="🚫" bg="rgba(193,18,31,0.1)"/>
              </div>
              {uploadResult.last_phone&&<div style={{background:'rgba(45,106,79,0.08)',border:'1px solid rgba(45,106,79,0.15)',borderRadius:'var(--r-sm)',padding:16,marginTop:8}}>
                <div style={{fontSize:11,color:'var(--text3)',fontWeight:700}}>LAST UPLOADED NUMBER</div>
                <div style={{fontFamily:'JetBrains Mono,monospace',fontSize:15,color:'var(--green)',fontWeight:700,marginTop:4}}>{uploadResult.last_phone}</div>
              </div>}
              {uploadResult.conflicts?.length>0&&(
                <div style={{marginTop:12,background:'rgba(201,168,76,0.06)',border:'1px solid rgba(201,168,76,0.2)',borderRadius:'var(--r)',padding:16}}>
                  <div style={{fontWeight:700,color:'#8a6d00',marginBottom:10}}>⚠️ {uploadResult.conflicts.length} Numbers Already Assigned</div>
                  <table className="tbl">
                    <thead><tr><th>Phone</th><th>Name</th><th>Status</th><th>Assigned To</th></tr></thead>
                    <tbody>{uploadResult.conflicts.map((c,i)=>(
                      <tr key={i}>
                        <td style={{fontFamily:'JetBrains Mono,monospace',color:'var(--gold)',fontWeight:700}}>{c.phone}</td>
                        <td>{c.name||'—'}</td>
                        <td><Badge color="orange">{c.pool}</Badge></td>
                        <td>{c.assigned_to}</td>
                      </tr>
                    ))}</tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </Card>
      )}

      <Card>
        <div className="tabs">
          {pools.map(p=><button key={p} className={`tab${pool===p?' active':''}`} onClick={()=>{setPool(p);setPage(1);setSelectedIds([]);}} style={{textTransform:'capitalize'}}>{p}</button>)}
        </div>
        <div style={{display:'flex',gap:12,marginBottom:16,flexWrap:'wrap'}}>
          <div className="search-bar" style={{flex:1,margin:0}}>
            <span style={{color:'var(--text3)'}}>🔍</span>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search by name or phone..." onKeyDown={e=>e.key==='Enter'&&load()}/>
            {search&&<button onClick={()=>setSearch('')} style={{background:'none',color:'var(--text3)',fontSize:16,border:'none',cursor:'pointer'}}>✕</button>}
          </div>
          <select className="sel" value={productId} onChange={e=>{setProductId(e.target.value);setPage(1);}} style={{width:180}}>
            <option value="">All Products</option>
            {products.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </div>
        {selectedIds.length>0&&pool!=='converted'&&(
          <div style={{display:'flex',gap:10,alignItems:'center',padding:'12px 16px',background:'rgba(45,106,79,0.06)',border:'1px solid rgba(45,106,79,0.15)',borderRadius:'var(--r-sm)',marginBottom:16,flexWrap:'wrap'}}>
            <span style={{color:'var(--green)',fontWeight:600}}>{selectedIds.length} selected</span>
            <select className="sel" value={assignUser} onChange={e=>setAssignUser(e.target.value)} style={{width:180,padding:'7px 12px'}}>
              <option value="">Select {user.role==='admin'?'TL':'Caller'}</option>
              {users.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
            </select>
            <Btn color="green" size="sm" onClick={assignSelected}>Assign Selected</Btn>
            <Btn color="ghost" size="sm" onClick={()=>setSelectedIds(leads.map(l=>l.id))}>Select All</Btn>
            <Btn color="ghost" size="sm" onClick={()=>setSelectedIds([])}>Clear</Btn>
          </div>
        )}
        <div style={{color:'var(--text3)',fontSize:12,marginBottom:12}}>{total} records · Page {page} · <small>Shift+Click for range select</small></div>
        {loading?<Spin/>:leads.length===0?<Empty title={`No ${pool} leads`}/>:(
          <div style={{overflowX:'auto'}}>
            <table className="tbl">
              <thead><tr>
                <th>{pool!=='converted'&&<input type="checkbox" onChange={e=>e.target.checked?setSelectedIds(leads.map(l=>l.id)):setSelectedIds([])} style={{cursor:'pointer'}}/>}</th>
                <th>#</th><th>Name</th><th>Phone</th><th>Product</th>
                <th>{user.role==='admin'?'Assigned TL':'Caller'}</th>
                <th>Last Status</th><th>Last Remark</th><th>Actions</th>
              </tr></thead>
              <tbody>{leads.map((l,idx)=>(
                <tr key={l.id}>
                  <td>{pool!=='converted'&&<input type="checkbox" checked={selectedIds.includes(l.id)} onChange={e=>toggleSel(l.id,idx,e)} style={{cursor:'pointer'}}/>}</td>
                  <td style={{color:'var(--text3)',fontSize:12}}>{(page-1)*50+idx+1}</td>
                  <td style={{fontWeight:600}}>{l.name||'—'}</td>
                  <td style={{fontFamily:'JetBrains Mono,monospace',color:'var(--green)',fontWeight:700}}>{l.phone}</td>
                  <td><Badge color="green">{l.product_name}</Badge></td>
                  <td style={{color:'var(--text2)'}}>{user.role==='admin'?(l.tl_name||<Badge color="gray">Unassigned</Badge>):(l.caller_name||<Badge color="gray">Unassigned</Badge>)}</td>
                  <td>{l.last_disposition?<Badge color={l.last_disposition==='CONV'?'green':l.last_disposition==='FU'?'gold':'gray'}>{l.last_disposition}</Badge>:'—'}</td>
                  <td style={{color:'var(--text3)',fontSize:12,maxWidth:150,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{l.last_remark||'—'}</td>
                  <td>
                    <div style={{display:'flex',gap:4,flexWrap:'wrap'}}>
                      <Btn size="sm" color="ghost" onClick={()=>viewHist(l.id)}>History</Btn>
                      {user.role==='admin'&&pool!=='converted'&&<Btn size="sm" color="blue" onClick={async()=>{if(!window.confirm('Mark as converted?'))return;const r=await api('leads.php?action=admin_convert','POST',{lead_id:l.id});if(r.status==='success'){toast('Converted!');load();}else toast(r.message,'error');}}>Conv</Btn>}
                      {user.role==='admin'&&pool==='converted'&&<Btn size="sm" color="gold" onClick={async()=>{if(!window.confirm('Move back to recent?'))return;const r=await api('leads.php?action=admin_to_recent','POST',{lead_id:l.id});if(r.status==='success'){toast('Moved!');load();}else toast(r.message,'error');}}>→Recent</Btn>}
                    </div>
                  </td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        )}
        <div style={{display:'flex',gap:10,marginTop:16,justifyContent:'center'}}>
          <Btn color="ghost" size="sm" disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</Btn>
          <span style={{padding:'7px 14px',color:'var(--text2)'}}>Page {page}</span>
          <Btn color="ghost" size="sm" disabled={leads.length<50} onClick={()=>setPage(p=>p+1)}>Next →</Btn>
        </div>
      </Card>

      <div className={`modal-bg${histModal?' open':''}`} onClick={e=>e.target===e.currentTarget&&setHistModal(null)}>
        <div className="modal">
          <div className="modal-title">📋 Call History</div>
          {history.length===0?<Empty title="No history"/>:history.map((h,i)=>(
            <div key={i} className="hist-item">
              <span className="hist-time">{h.attempted_at?.slice(0,16)}</span>
              <Badge color={h.disposition==='CONV'?'green':h.disposition==='FU'?'gold':'gray'}>{h.disposition}</Badge>
              <div style={{flex:1}}>{h.remark&&<div style={{fontSize:13}}>{h.remark}</div>}<div style={{color:'var(--text3)',fontSize:11,marginTop:2}}>by {h.by_name}</div></div>
            </div>
          ))}
          <div style={{marginTop:20,display:'flex',justifyContent:'flex-end'}}><Btn color="ghost" onClick={()=>setHistModal(null)}>Close</Btn></div>
        </div>
      </div>

      <div className={`modal-bg${showRollConfirm?' open':''}`} onClick={e=>e.target===e.currentTarget&&setShowRollConfirm(false)}>
        <div className="modal" style={{maxWidth:400}}>
          <div className="modal-title">🔄 Roll Recent Data</div>
          <p style={{color:'var(--text2)',fontSize:14,marginBottom:16,lineHeight:1.7}}>All recent leads assigned to callers will return to your pool.<br/><span style={{color:'var(--red)',fontSize:13}}>Callers will lose access to these leads!</span></p>
          <div style={{background:'rgba(201,168,76,0.06)',border:'1px solid rgba(201,168,76,0.2)',borderRadius:'var(--r-sm)',padding:'12px 16px',marginBottom:20}}>
            <div style={{fontSize:13,color:'var(--text2)'}}>Range: <strong style={{color:'var(--gold)'}}>{recentDays===0?'All time':`Last ${recentDays} days`}</strong></div>
          </div>
          <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
            <Btn color="ghost" onClick={()=>setShowRollConfirm(false)}>Cancel</Btn>
            <Btn color="gold" onClick={async()=>{const r=await api('leads.php?action=roll_recent','POST',{product_id:productId||null,days:recentDays});if(r.status==='success'){toast(`${r.data.rolled} leads rolled back!`);setShowRollConfirm(false);load();}else toast(r.message,'error');}}>Confirm Roll</Btn>
          </div>
        </div>
      </div>
    </>
  );
}

// ─── ASSIGNMENT ────────────────────────────────────────────────────────────
function Assignment({ user, products }) {
  const [mode,setMode]=useState('bulk');
  const [form,setForm]=useState({product_id:'',pool:'fresh',to_id:'',quantity:10});
  const [users,setUsers]=useState([]);
  const [poolStats,setPoolStats]=useState([]);
  const [result,setResult]=useState(null);
  const [minusForm,setMinusForm]=useState({from_id:'',product_id:'',quantity:5});
  const [loading,setLoading]=useState(false);
  const [recentDays,setRecentDays]=useState(()=>parseInt(localStorage.getItem('pa_rd')||'7'));

  useEffect(()=>{
    if(user.role==='admin')api('users.php?action=list&role=tl').then(r=>{if(r.status==='success')setUsers(r.data);});
    else api('users.php?action=list').then(r=>{if(r.status==='success')setUsers(r.data.filter(u=>u.role==='caller'&&String(u.tl_id)===String(user.id)));});
  },[user]);
  useEffect(()=>{if(form.product_id)api(`leads.php?action=pool_stats&product_id=${form.product_id}`).then(r=>{if(r.status==='success')setPoolStats(r.data);});},[form.product_id]);

  const assign=async()=>{
    if(!form.product_id||!form.to_id||!form.quantity)return toast('All fields required','error');
    setLoading(true);
    const r=await api('leads.php?action=assign_bulk','POST',{...form,days:recentDays});
    if(r.status==='success'){setResult(r.data);toast(`${r.data.assigned} leads assigned!`);}
    else toast(r.message,'error');
    setLoading(false);
  };

  const doMinus=async()=>{
    if(!minusForm.from_id||!minusForm.quantity)return toast('Fill all fields','error');
    const r=await api('leads.php?action=minus_leads','POST',minusForm);
    if(r.status==='success')toast(`${r.data.returned} leads returned`);
    else toast(r.message,'error');
  };

  const getPoolStat=p=>poolStats.find(s=>s.pool===p)||{total:0,unassigned:0,assigned:0};

  return(
    <>
      <div className="tabs" style={{maxWidth:300}}>
        <button className={`tab${mode==='bulk'?' active':''}`} onClick={()=>setMode('bulk')}>Bulk Assign</button>
        <button className={`tab${mode==='minus'?' active':''}`} onClick={()=>setMode('minus')}>Minus Leads</button>
      </div>
      {mode==='bulk'&&(
        <div className="g2">
          <Card>
            <CT icon="🎯">Assign Leads</CT>
            <Sel label="Product" value={form.product_id} onChange={e=>setForm({...form,product_id:e.target.value})}>
              <option value="">-- Select Product --</option>
              {products.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
            </Sel>
            <Sel label="Pool" value={form.pool} onChange={e=>setForm({...form,pool:e.target.value})}>
              <option value="fresh">Fresh Data</option>
              <option value="recent">Recent Data</option>
            </Sel>
            {form.pool==='recent'&&(
              <div>
                <label className="flabel">Recent Data Range</label>
                <select className="sel" value={recentDays} onChange={e=>{const v=parseInt(e.target.value);setRecentDays(v);localStorage.setItem('pa_rd',v);}}>
                  <option value="3">Last 3 days</option><option value="7">Last 7 days</option>
                  <option value="15">Last 15 days</option><option value="30">Last 30 days</option><option value="0">All time</option>
                </select>
              </div>
            )}
            <Sel label={user.role==='admin'?'Team Lead':'Caller'} value={form.to_id} onChange={e=>setForm({...form,to_id:e.target.value})}>
              <option value="">-- Select --</option>
              {users.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
            </Sel>
            <Inp label="Number of Leads" type="number" value={form.quantity} onChange={e=>setForm({...form,quantity:e.target.value})} min={1} max={500}/>
            {result&&<div style={{background:'rgba(45,106,79,0.08)',border:'1px solid rgba(45,106,79,0.2)',borderRadius:'var(--r-sm)',padding:14,marginBottom:16,color:'var(--green)',fontWeight:600}}>✅ {result.assigned} leads assigned!</div>}
            <Btn color="green" full onClick={assign} disabled={loading}>{loading?'Assigning...':'Assign Leads'}</Btn>
          </Card>
          <Card>
            <CT icon="📊">Pool Status</CT>
            {form.product_id?['fresh','recent','followup','converted'].map(p=>{
              const s=getPoolStat(p);
              return(
                <div key={p} style={{padding:'14px 0',borderBottom:'1px solid var(--border)'}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                    <Badge color={p==='fresh'?'green':p==='recent'?'gold':p==='followup'?'orange':'blue'} style={{textTransform:'capitalize'}}>{p}</Badge>
                    <span style={{fontWeight:700,fontSize:18}}>{s.total}</span>
                  </div>
                  <div style={{display:'flex',gap:20,fontSize:12,color:'var(--text3)'}}>
                    <span>Unassigned: <strong style={{color:'var(--green)'}}>{s.unassigned}</strong></span>
                    <span>Assigned: <strong style={{color:'var(--gold)'}}>{s.assigned}</strong></span>
                  </div>
                </div>
              );
            }):<Empty title="Select a product to view stats"/>}
          </Card>
        </div>
      )}
      {mode==='minus'&&(
        <Card>
          <CT icon="➖">Minus Leads (Silent Return)</CT>
          <div className="g2">
            <div>
              <Sel label={user.role==='admin'?'From TL':'From Caller'} value={minusForm.from_id} onChange={e=>setMinusForm({...minusForm,from_id:e.target.value})}>
                <option value="">-- Select --</option>
                {users.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
              </Sel>
              <Sel label="Product (optional)" value={minusForm.product_id} onChange={e=>setMinusForm({...minusForm,product_id:e.target.value})}>
                <option value="">All Products</option>
                {products.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
              </Sel>
              <Inp label="Quantity" type="number" value={minusForm.quantity} onChange={e=>setMinusForm({...minusForm,quantity:e.target.value})} min={1}/>
              <Btn color="gold" full onClick={doMinus}>Return Leads Silently</Btn>
            </div>
            <div style={{background:'rgba(201,168,76,0.05)',border:'1px solid rgba(201,168,76,0.15)',borderRadius:'var(--r)',padding:20}}>
              <h4 style={{color:'var(--gold)',marginBottom:12}}>ℹ️ Rules</h4>
              <ul style={{color:'var(--text2)',fontSize:13,lineHeight:2,paddingLeft:16}}>
                <li>Only 0-attempt leads are returned</li>
                <li>No notification sent to user</li>
                <li>Follow up & converted leads exempt</li>
                <li>Punch pending leads are exempt</li>
              </ul>
            </div>
          </div>
        </Card>
      )}
    </>
  );
}

// ─── ATTENDANCE ────────────────────────────────────────────────────────────
function AttendancePage({ user }) {
  const [records,setRecords]=useState([]);
  const [date,setDate]=useState(new Date().toISOString().slice(0,10));
  const [loading,setLoading]=useState(true);
  const [tls,setTls]=useState([]);
  const [selectedTl,setSelectedTl]=useState('');
  const [saving,setSaving]=useState(false);
  const [localStatus,setLocalStatus]=useState({});

  const load=useCallback(async()=>{
    setLoading(true);
    let url=`users.php?action=get_attendance&date=${date}`;
    if(user.role==='admin'&&selectedTl)url+=`&tl_id=${selectedTl}`;
    const r=await api(url);
    if(r.status==='success'){setRecords(r.data);const ls={};r.data.forEach(u=>ls[u.id]=u.status);setLocalStatus(ls);}
    setLoading(false);
  },[date,user,selectedTl]);

  useEffect(()=>{load();},[load]);
  useEffect(()=>{if(user.role==='admin')api('users.php?action=list&role=tl').then(r=>{if(r.status==='success')setTls(r.data);});},[user]);

  const saveAll=async()=>{
    setSaving(true);
    const recs=Object.entries(localStatus).map(([uid,status])=>({user_id:parseInt(uid),status}));
    const r=await api('users.php?action=mark_attendance','POST',{records:recs,date});
    if(r.status==='success')toast('Attendance saved!');else toast(r.message,'error');
    setSaving(false);
  };

  const present=Object.values(localStatus).filter(s=>s==='present').length;
  return(
    <Card>
      <CT icon="✅">Daily Attendance</CT>
      <div style={{display:'flex',gap:12,marginBottom:20,flexWrap:'wrap',alignItems:'flex-end'}}>
        <div><label className="flabel">Date</label><input className="inp" type="date" value={date} onChange={e=>setDate(e.target.value)} style={{width:160}} max={new Date().toISOString().slice(0,10)}/></div>
        {user.role==='admin'&&(
          <div><label className="flabel">Team Lead</label>
            <select className="sel" value={selectedTl} onChange={e=>setSelectedTl(e.target.value)} style={{width:180}}>
              <option value="">All TLs</option>
              {tls.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </div>
        )}
        <Btn color="gold" onClick={saveAll} disabled={saving}>{saving?'Saving...':'💾 Save Attendance'}</Btn>
      </div>
      <div style={{display:'flex',gap:16,marginBottom:16}}>
        <Badge color="green">Present: {present}</Badge>
        <Badge color="red">Absent: {records.length-present}</Badge>
        <Badge color="gray">Total: {records.length}</Badge>
      </div>
      {loading?<Spin/>:records.length===0?<Empty title="No users found"/>:(
        <table className="tbl">
          <thead><tr><th>Name</th><th>Role</th><th>Mark Attendance</th></tr></thead>
          <tbody>{records.map(u=>(
            <tr key={u.id}>
              <td style={{fontWeight:600}}>{u.name}</td>
              <td><Badge color={u.role==='tl'?'blue':'gray'}>{u.role.toUpperCase()}</Badge></td>
              <td>
                <div style={{display:'flex',gap:8}}>
                  <button className={`att-btn att-present${localStatus[u.id]==='present'?' att-active':''}`} onClick={()=>setLocalStatus(p=>({...p,[u.id]:'present'}))}>✓ Present</button>
                  <button className={`att-btn att-absent${localStatus[u.id]==='absent'?' att-active':''}`} onClick={()=>setLocalStatus(p=>({...p,[u.id]:'absent'}))}>✗ Absent</button>
                </div>
              </td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </Card>
  );
}

// ─── ADMIN ACCOUNTS ────────────────────────────────────────────────────────
function AdminAccounts() {
  const [tls,setTls]=useState([]);
  const [inactive,setInactive]=useState([]);
  const [open,setOpen]=useState({});
  const [showCreate,setShowCreate]=useState(false);
  const [form,setForm]=useState({name:'',email:'',password:'Pass@1234',role:'caller',tl_id:''});
  const [loading,setLoading]=useState(true);
  const [editUser,setEditUser]=useState(null);
  const [editForm,setEditForm]=useState({});
  const [showInactive,setShowInactive]=useState(false);

  const load=useCallback(async()=>{
    const r=await api('users.php?action=hierarchy');
    if(r.status==='success'){
      setTls(r.data.filter(t=>t.is_active));
      const inact=[];
      r.data.filter(t=>!t.is_active).forEach(t=>inact.push(t));
      r.data.forEach(t=>t.callers?.filter(c=>!c.is_active).forEach(c=>inact.push(c)));
      setInactive(inact);
    }
    setLoading(false);
  },[]);
  useEffect(()=>{load();},[load]);

  const create=async()=>{
    const r=await api('users.php?action=create','POST',form);
    if(r.status==='success'){toast('Account created! Password: '+form.password);setShowCreate(false);load();setForm({name:'',email:'',password:'Pass@1234',role:'caller',tl_id:''});}
    else toast(r.message,'error');
  };
  const update=async()=>{
    const payload={id:editUser.id,...editForm};
    if(!editForm.password)delete payload.password;
    const r=await api('users.php?action=update','PUT',payload);
    if(r.status==='success'){toast('Updated!');setEditUser(null);load();}else toast(r.message,'error');
  };
  const toggleUser=async(id,isActive)=>{await api('users.php?action=update','PUT',{id,is_active:isActive?0:1});load();};
  const resetPass=async id=>{const p='Pass@'+Math.floor(1000+Math.random()*9000);await api('users.php?action=update','PUT',{id,password:p});toast(`New password: ${p}`,'info');};
  const deleteUser=async u=>{
    if(!window.confirm(`Delete ${u.name}? Their leads will be unassigned!`))return;
    const r=await api('users.php?action=delete','DELETE',{id:u.id});
    if(r.status==='success'){toast('Deleted.','info');load();}else toast(r.message,'error');
  };

  if(loading)return<Spin/>;
  return(
    <>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
        <div>
          <Badge color="green" style={{marginRight:8}}>{tls.length+tls.reduce((a,t)=>a+(t.callers?.filter(c=>c.is_active).length||0),0)} Active</Badge>
          <Badge color="red">{inactive.length} Inactive</Badge>
        </div>
        <div style={{display:'flex',gap:10}}>
          <Btn color="ghost" onClick={()=>setShowInactive(!showInactive)}>{showInactive?'Hide':'Show'} Inactive</Btn>
          <Btn color="green" onClick={()=>setShowCreate(true)}>+ New Account</Btn>
        </div>
      </div>
      {tls.map(tl=>(
        <div key={tl.id} className="accordion-item">
          <div className="accordion-hd" onClick={()=>setOpen(p=>({...p,[tl.id]:!p[tl.id]}))}>
            <div style={{width:36,height:36,borderRadius:'50%',background:'linear-gradient(135deg,var(--green),var(--green2))',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:700,flexShrink:0}}>{tl.name[0]}</div>
            <div style={{flex:1}}>
              <div style={{fontWeight:700}}>{tl.name}</div>
              <div style={{fontSize:12,color:'var(--text3)'}}>{tl.email} · {tl.callers?.filter(c=>c.is_active).length||0} callers</div>
            </div>
            <Badge color="blue">TL</Badge>
            <div style={{display:'flex',gap:6,marginLeft:10}} onClick={e=>e.stopPropagation()}>
              <Btn size="sm" color="ghost" onClick={()=>{setEditUser(tl);setEditForm({name:tl.name,email:tl.email});}}>Edit</Btn>
              <Btn size="sm" color="ghost" onClick={()=>resetPass(tl.id)}>Reset Pass</Btn>
              <Btn size="sm" color="red" onClick={()=>toggleUser(tl.id,tl.is_active)}>Deactivate</Btn>
              <Btn size="sm" color="red" onClick={()=>deleteUser(tl)}>Delete</Btn>
            </div>
            <span style={{marginLeft:10,color:'var(--text3)'}}>{open[tl.id]?'▲':'▼'}</span>
          </div>
          {open[tl.id]&&(
            <div className="accordion-bd">
              {tl.callers?.filter(c=>c.is_active).length===0?<div style={{padding:'14px 0',color:'var(--text3)'}}>No active callers</div>:
                tl.callers?.filter(c=>c.is_active).map(c=>(
                  <div key={c.id} style={{display:'flex',alignItems:'center',gap:12,padding:'12px 0',borderBottom:'1px solid var(--border)'}}>
                    <div style={{width:30,height:30,borderRadius:'50%',background:'rgba(201,168,76,0.15)',display:'flex',alignItems:'center',justifyContent:'center',color:'var(--gold)',fontWeight:700,fontSize:12,flexShrink:0}}>{c.name[0]}</div>
                    <div style={{flex:1}}><div style={{fontWeight:600,fontSize:13}}>{c.name}</div><div style={{fontSize:11,color:'var(--text3)'}}>{c.email}</div></div>
                    <div style={{display:'flex',gap:6}}>
                      <Btn size="sm" color="ghost" onClick={()=>{setEditUser(c);setEditForm({name:c.name,email:c.email});}}>Edit</Btn>
                      <Btn size="sm" color="ghost" onClick={()=>resetPass(c.id)}>Reset</Btn>
                      <Btn size="sm" color="red" onClick={()=>toggleUser(c.id,c.is_active)}>Deactivate</Btn>
                      <Btn size="sm" color="red" onClick={()=>deleteUser(c)}>Delete</Btn>
                    </div>
                  </div>
                ))
              }
              <div style={{paddingTop:12}}><Btn size="sm" color="green" onClick={()=>{setShowCreate(true);setForm(f=>({...f,role:'caller',tl_id:tl.id}));}}>+ Add Caller to this TL</Btn></div>
            </div>
          )}
        </div>
      ))}
      {showInactive&&inactive.length>0&&(
        <>
          <div style={{marginTop:20,marginBottom:8,color:'var(--red)',fontSize:12,fontWeight:700,textTransform:'uppercase',letterSpacing:1}}>Inactive Accounts</div>
          {inactive.map(u=>(
            <div key={u.id} style={{display:'flex',alignItems:'center',gap:12,padding:'12px 16px',background:'rgba(193,18,31,0.03)',border:'1px solid rgba(193,18,31,0.12)',borderRadius:'var(--r)',marginBottom:8}}>
              <div style={{width:36,height:36,borderRadius:'50%',background:'rgba(193,18,31,0.1)',display:'flex',alignItems:'center',justifyContent:'center',color:'var(--red)',fontWeight:700,flexShrink:0}}>{u.name[0]}</div>
              <div style={{flex:1}}><div style={{fontWeight:700}}>{u.name} <Badge color="gray">{u.role}</Badge></div><div style={{fontSize:11,color:'var(--text3)'}}>{u.email}</div></div>
              <Btn size="sm" color="green" onClick={()=>toggleUser(u.id,false)}>Activate</Btn>
              <Btn size="sm" color="red" onClick={()=>deleteUser(u)}>Delete</Btn>
            </div>
          ))}
        </>
      )}
      <div className={`modal-bg${showCreate?' open':''}`} onClick={e=>e.target===e.currentTarget&&setShowCreate(false)}>
        <div className="modal">
          <div className="modal-title">Create New Account</div>
          <Inp label="Full Name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})}/>
          <Inp label="Email Address" type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})}/>
          <PasswordInput label="Password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})}/>
          <Sel label="Role" value={form.role} onChange={e=>setForm({...form,role:e.target.value})}>
            <option value="caller">Caller</option><option value="tl">Team Lead</option><option value="admin">Admin</option>
          </Sel>
          {form.role==='caller'&&(
            <Sel label="Assign to TL" value={form.tl_id} onChange={e=>setForm({...form,tl_id:e.target.value})}>
              <option value="">-- Select TL --</option>
              {tls.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
            </Sel>
          )}
          <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
            <Btn color="ghost" onClick={()=>setShowCreate(false)}>Cancel</Btn>
            <Btn color="green" onClick={create}>Create Account</Btn>
          </div>
        </div>
      </div>
      <div className={`modal-bg${editUser?' open':''}`} onClick={e=>e.target===e.currentTarget&&setEditUser(null)}>
        <div className="modal">
          <div className="modal-title">Edit: {editUser?.name}</div>
          <Inp label="Full Name" value={editForm.name||''} onChange={e=>setEditForm({...editForm,name:e.target.value})}/>
          <Inp label="Email Address" value={editForm.email||''} onChange={e=>setEditForm({...editForm,email:e.target.value})}/>
          <PasswordInput label="New Password (leave blank to keep)" value={editForm.password||''} onChange={e=>setEditForm({...editForm,password:e.target.value})}/>
          <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
            <Btn color="ghost" onClick={()=>setEditUser(null)}>Cancel</Btn>
            <Btn color="green" onClick={update}>Save Changes</Btn>
          </div>
        </div>
      </div>
    </>
  );
}

// ─── ADMIN PRODUCTS ────────────────────────────────────────────────────────
function AdminProducts() {
  const [list,setList]=useState([]);
  const [form,setForm]=useState({name:'',script:'',min_price:0});
  const load=async()=>{const r=await api('misc.php?type=products&action=list');if(r.status==='success')setList(r.data);};
  useEffect(()=>{load();},[]);
  const create=async()=>{
    if(!form.name.trim())return toast('Name required','error');
    const r=await api('misc.php?type=products&action=create','POST',form);
    if(r.status==='success'){toast('Product created!');setForm({name:'',script:'',min_price:0});load();}else toast(r.message,'error');
  };
  const toggle=async(id,isActive)=>{await api('misc.php?type=products&action=update','PUT',{id,is_active:isActive?0:1});toast(isActive?'Disabled':'Enabled');load();};
  const doDelete=async p=>{
    if(!window.confirm(`Delete "${p.name}"? This permanently deletes ${p.total_leads} leads!`))return;
    const r=await api('misc.php?type=products&action=delete','DELETE',{id:p.id});
    if(r.status==='success'){toast('Deleted permanently','info');load();}else toast(r.message,'error');
  };
  return(
    <div className="g2">
      <Card>
        <CT icon="📦">Add Product</CT>
        <Inp label="Product Name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="PushpAmrit Oil"/>
        <Inp label="Minimum Price (₹)" type="number" value={form.min_price} onChange={e=>setForm({...form,min_price:e.target.value})} min={0}/>
        <TA label="Calling Script (optional)" value={form.script} onChange={e=>setForm({...form,script:e.target.value})} rows={6} placeholder="Hello! I am calling from PushpAmrit Wellness..."/>
        <Btn color="green" full onClick={create}>Create Product</Btn>
      </Card>
      <Card>
        <CT icon="📋">All Products</CT>
        {list.map(p=>(
          <div key={p.id} style={{padding:'14px 0',borderBottom:'1px solid var(--border)'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
              <div>
                <div style={{fontWeight:700,fontSize:15}}>{p.name}</div>
                <div style={{color:'var(--text3)',fontSize:12,marginTop:2}}>Min ₹{p.min_price}</div>
                <div style={{display:'flex',gap:16,marginTop:6,fontSize:12}}>
                  <span>Total: <strong style={{color:'var(--blue)'}}>{p.total_leads||0}</strong></span>
                  <span>Fresh: <strong style={{color:'var(--green)'}}>{p.fresh_count||0}</strong></span>
                  <span>Converted: <strong style={{color:'var(--gold)'}}>{p.converted_count||0}</strong></span>
                </div>
              </div>
              <Badge color={p.is_active?'green':'red'}>{p.is_active?'Active':'Disabled'}</Badge>
            </div>
            <div style={{display:'flex',gap:8}}>
              <Btn size="sm" color="ghost" onClick={()=>toggle(p.id,p.is_active)}>{p.is_active?'Disable':'Enable'}</Btn>
              <Btn size="sm" color="red" onClick={()=>doDelete(p)}>🗑️ Delete All Data</Btn>
            </div>
          </div>
        ))}
        {!list.length&&<Empty title="No products yet"/>}
      </Card>
    </div>
  );
}

// ─── BLACKLIST ─────────────────────────────────────────────────────────────
function BlacklistPage({ user }) {
  const [list,setList]=useState([]);
  const [phones,setPhones]=useState('');
  const [reason,setReason]=useState('');
  const [search,setSearch]=useState('');
  const load=async()=>{const r=await api(`misc.php?type=blacklist&action=list&search=${search}`);if(r.status==='success')setList(r.data);};
  useEffect(()=>{load();},[search]);
  const add=async()=>{
    const arr=phones.split('\n').map(p=>p.trim()).filter(Boolean);
    if(!arr.length)return toast('Enter phone numbers','error');
    const r=await api('misc.php?type=blacklist&action=add','POST',{phones:arr,reason,force:true});
    if(r.status==='success'){toast(`${r.data.added} numbers blacklisted`);setPhones('');setReason('');load();}
    else toast(r.message,'error');
  };
  const remove=async id=>{await api('misc.php?type=blacklist&action=remove','DELETE',{id});toast('Removed');load();};
  return(
    <div className="g2">
      <Card>
        <CT icon="🚫">Add to Blacklist</CT>
        <TA label="Phone Numbers (one per line)" value={phones} onChange={e=>setPhones(e.target.value)} rows={7} placeholder={"9876543210\n9876543211\n+919876543212"}/>
        <Inp label="Reason (optional)" value={reason} onChange={e=>setReason(e.target.value)} placeholder="DND, Abuse, Spam..."/>
        <Btn color="red" full onClick={add}>🚫 Add to Blacklist</Btn>
      </Card>
      <Card>
        <CT icon="📋">Blacklisted Numbers</CT>
        <div className="search-bar" style={{marginBottom:14}}>
          <span>🔍</span>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search by phone..."/>
        </div>
        {list.length?(
          <table className="tbl">
            <thead><tr><th>Phone</th><th>Reason</th><th>Date</th>{user.role==='admin'&&<th></th>}</tr></thead>
            <tbody>{list.map(b=>(
              <tr key={b.id}>
                <td style={{fontFamily:'JetBrains Mono,monospace',color:'var(--red)',fontWeight:700}}>{b.phone}</td>
                <td style={{color:'var(--text3)'}}>{b.reason||'—'}</td>
                <td style={{fontSize:12,color:'var(--text3)'}}>{b.created_at?.slice(0,10)}</td>
                {user.role==='admin'&&<td><Btn size="sm" color="ghost" onClick={()=>remove(b.id)}>Remove</Btn></td>}
              </tr>
            ))}</tbody>
          </table>
        ):<Empty title="Blacklist is empty"/>}
      </Card>
    </div>
  );
}

// ─── ADMIN REPORTS ─────────────────────────────────────────────────────────
function AdminReports({ products }) {
  const [from,setFrom]=useState(new Date().toISOString().slice(0,8)+'01');
  const [to,setTo]=useState(new Date().toISOString().slice(0,10));
  const [report,setReport]=useState([]);
  const [dataPool,setDataPool]=useState('all');
  const [dataProduct,setDataProduct]=useState('');
  const [dataRows,setDataRows]=useState([]);
  const [copied,setCopied]=useState(false);
  const [copiedData,setCopiedData]=useState(false);
  // Converted Report
  const [convFrom,setConvFrom]=useState(new Date().toISOString().slice(0,8)+'01');
  const [convTo,setConvTo]=useState(new Date().toISOString().slice(0,10));
  const [convProduct,setConvProduct]=useState('');
  const [convRows,setConvRows]=useState([]);
  const [convStats,setConvStats]=useState(null);
  const [convCopied,setConvCopied]=useState(false);
  const [convLoading,setConvLoading]=useState(false);

  const load=async()=>{const r=await api(`reports.php?action=admin_tl_report&from=${from}&to=${to}`);if(r.status==='success')setReport(r.data);else toast(r.message,'error');};
  const loadData=async()=>{const r=await api(`reports.php?action=get_data_copy&pool=${dataPool}&product_id=${dataProduct}`);if(r.status==='success')setDataRows(r.data);else toast(r.message,'error');};

  const loadConv=async()=>{
    setConvLoading(true);
    const r=await api(`reports.php?action=converted_report&from=${convFrom}&to=${convTo}&product_id=${convProduct}`);
    if(r.status==='success'){setConvRows(r.data.rows);setConvStats({total_orders:r.data.total_orders,total_amount:r.data.total_amount});}
    else toast(r.message,'error');
    setConvLoading(false);
  };

  const copyReport=()=>{
    if(!report.length)return;
    const h='TL\tTotal Leads\tConverted\tTeam Size\tPunch Orders';
    const rows=report.map(r=>`${r.tl}\t${r.total_leads}\t${r.converted}\t${r.team_size}\t${r.punch_orders}`);
    navigator.clipboard.writeText([h,...rows].join('\n')).then(()=>{setCopied(true);toast('Copied!');setTimeout(()=>setCopied(false),3000);});
  };
  const copyData=()=>{
    if(!dataRows.length)return;
    const h=Object.keys(dataRows[0]).join('\t');
    const body=dataRows.map(r=>Object.values(r).map(v=>v||'').join('\t')).join('\n');
    navigator.clipboard.writeText(h+'\n'+body).then(()=>{setCopiedData(true);toast(`${dataRows.length} rows copied!`);setTimeout(()=>setCopiedData(false),3000);});
  };
  const copyConv=()=>{
    if(!convRows.length)return;
    const h='Date\tCustomer\tPhone\tProduct\tTL\tCaller\tQty\tPrice (₹)\tCity\tAddress\tRemark';
    const rows=convRows.map(r=>`${r.PunchDate?.slice(0,16)||r.ConvertedAt?.slice(0,16)||''}\t${r.PunchName||r.Customer||''}\t${r.Phone}\t${r.Product}\t${r.TL}\t${r.Caller}\t${r.Qty||1}\t${r.Price||0}\t${r.City||''}\t${r.Address||''}\t${r.PunchRemark||''}`);
    navigator.clipboard.writeText([h,...rows].join('\n')).then(()=>{setConvCopied(true);toast(`${convRows.length} rows copied!`);setTimeout(()=>setConvCopied(false),3000);});
  };

  return(
    <>
      <Card>
        <CT icon="📈">TL-wise Report</CT>
        <div style={{display:'flex',gap:12,marginBottom:20,flexWrap:'wrap',alignItems:'flex-end'}}>
          <div><label className="flabel">From</label><input className="inp" type="date" value={from} onChange={e=>setFrom(e.target.value)} style={{width:160}}/></div>
          <div><label className="flabel">To</label><input className="inp" type="date" value={to} onChange={e=>setTo(e.target.value)} style={{width:160}}/></div>
          <Btn color="green" onClick={load}>Show Report</Btn>
          {report.length>0&&<Btn color="ghost" onClick={copyReport}>{copied?'✅ Copied!':'📋 Copy for Sheet'}</Btn>}
        </div>
        {report.length?(
          <table className="tbl">
            <thead><tr><th>TL Name</th><th>Total Leads</th><th>Converted</th><th>Team Size</th><th>Punch Orders</th></tr></thead>
            <tbody>{report.map((r,i)=>(
              <tr key={i}>
                <td style={{fontWeight:700}}>{r.tl}</td>
                <td>{r.total_leads}</td>
                <td style={{color:'var(--green)',fontWeight:800,fontSize:17}}>{r.converted}</td>
                <td>{r.team_size}</td>
                <td>{r.punch_orders}</td>
              </tr>
            ))}</tbody>
          </table>
        ):<Empty title="Click Show Report to load data"/>}
      </Card>

      {/* ── CONVERTED REPORT ── */}
      <Card>
        <CT icon="✅">Converted Orders Report</CT>
        <div style={{display:'flex',gap:12,marginBottom:16,flexWrap:'wrap',alignItems:'flex-end'}}>
          <div><label className="flabel">From</label><input className="inp" type="date" value={convFrom} onChange={e=>setConvFrom(e.target.value)} style={{width:160}}/></div>
          <div><label className="flabel">To</label><input className="inp" type="date" value={convTo} onChange={e=>setConvTo(e.target.value)} style={{width:160}}/></div>
          <Sel label="Product" value={convProduct} onChange={e=>setConvProduct(e.target.value)} style={{width:180}}>
            <option value="">All Products</option>
            {products.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
          </Sel>
          <Btn color="green" onClick={loadConv} disabled={convLoading}>{convLoading?'Loading...':'Show Report'}</Btn>
          {convRows.length>0&&<Btn color="ghost" onClick={copyConv}>{convCopied?'✅ Copied!':'📋 Copy for Sheet'}</Btn>}
        </div>
        {convStats&&(
          <div style={{display:'flex',gap:16,marginBottom:16}}>
            <div style={{background:'rgba(45,106,79,0.08)',border:'1px solid rgba(45,106,79,0.2)',borderRadius:'var(--r-sm)',padding:'10px 18px'}}>
              <div style={{fontSize:11,color:'var(--text3)',fontWeight:700}}>TOTAL ORDERS</div>
              <div style={{fontFamily:'Playfair Display,serif',fontSize:24,fontWeight:800,color:'var(--green)'}}>{convStats.total_orders}</div>
            </div>
            <div style={{background:'rgba(201,168,76,0.08)',border:'1px solid rgba(201,168,76,0.2)',borderRadius:'var(--r-sm)',padding:'10px 18px'}}>
              <div style={{fontSize:11,color:'var(--text3)',fontWeight:700}}>TOTAL AMOUNT</div>
              <div style={{fontFamily:'Playfair Display,serif',fontSize:24,fontWeight:800,color:'var(--gold)'}}>₹{parseFloat(convStats.total_amount||0).toLocaleString('en-IN')}</div>
            </div>
          </div>
        )}
        {convLoading?<Spin/>:convRows.length>0?(
          <div style={{overflowX:'auto',maxHeight:450,overflowY:'auto'}}>
            <table className="tbl">
              <thead><tr><th>Date</th><th>Customer</th><th>Phone</th><th>Product</th><th>TL</th><th>Caller</th><th>Qty</th><th>Price (₹)</th><th>City</th><th>Remark</th></tr></thead>
              <tbody>{convRows.map((r,i)=>(
                <tr key={i}>
                  <td style={{fontSize:12,color:'var(--text3)',fontFamily:'JetBrains Mono,monospace',whiteSpace:'nowrap'}}>{r.PunchDate?.slice(0,16)||r.ConvertedAt?.slice(0,16)||'—'}</td>
                  <td style={{fontWeight:600}}>{r.PunchName||r.Customer||'—'}</td>
                  <td style={{fontFamily:'JetBrains Mono,monospace',color:'var(--green)',fontWeight:700}}>{r.Phone}</td>
                  <td><Badge color="green">{r.Product}</Badge></td>
                  <td style={{color:'var(--text2)'}}>{r.TL}</td>
                  <td style={{fontWeight:600}}>{r.Caller}</td>
                  <td style={{textAlign:'center'}}>{r.Qty||1}</td>
                  <td style={{fontWeight:700,color:'var(--gold)'}}>₹{parseFloat(r.Price||0).toLocaleString('en-IN')}</td>
                  <td style={{color:'var(--text3)'}}>{r.City||'—'}</td>
                  <td style={{color:'var(--text3)',fontSize:12,maxWidth:150,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.PunchRemark||'—'}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        ):convStats?<Empty title="No converted orders in this range"/>:<Empty title="Click Show Report to load data"/>}
      </Card>

      <Card>
        <CT icon="📦">Data Export</CT>
        <div style={{display:'flex',gap:12,flexWrap:'wrap',alignItems:'flex-end',marginBottom:16}}>
          <Sel label="Pool" value={dataPool} onChange={e=>setDataPool(e.target.value)} style={{width:160}}>
            <option value="all">All Data</option><option value="fresh">Fresh</option>
            <option value="recent">Recent</option><option value="followup">Follow Up</option><option value="converted">Converted</option>
          </Sel>
          <Sel label="Product" value={dataProduct} onChange={e=>setDataProduct(e.target.value)} style={{width:180}}>
            <option value="">All Products</option>
            {products.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
          </Sel>
          <Btn color="green" onClick={loadData}>Load Data</Btn>
          {dataRows.length>0&&<Btn color="ghost" onClick={copyData}>{copiedData?'✅ Copied!':'📋 Copy for Sheet'}</Btn>}
        </div>
        {dataRows.length>0&&(
          <>
            <div style={{fontSize:12,color:'var(--text3)',marginBottom:10}}>{dataRows.length} records loaded</div>
            <div style={{overflowX:'auto',maxHeight:400,overflowY:'auto'}}>
              <table className="tbl">
                <thead><tr><th>Name</th><th>Phone</th><th>Product</th><th>Status</th><th>Last Disp</th><th>Last Remark</th><th>TL</th><th>Caller</th></tr></thead>
                <tbody>{dataRows.map((r,i)=>(
                  <tr key={i}>
                    <td>{r.Customer||'—'}</td>
                    <td style={{fontFamily:'JetBrains Mono,monospace',color:'var(--green)',fontWeight:700}}>{r.Phone}</td>
                    <td><Badge color="green">{r.Product}</Badge></td>
                    <td><Badge color={r.Status==='converted'?'green':r.Status==='fresh'?'blue':'gold'}>{r.Status}</Badge></td>
                    <td>{r.LastDisp||'—'}</td>
                    <td style={{maxWidth:120,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',color:'var(--text3)'}}>{r.LastRemark||'—'}</td>
                    <td>{r.TL}</td>
                    <td>{r.Caller}</td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          </>
        )}
      </Card>
    </>
  );
}

// ─── ADMIN SETTINGS ────────────────────────────────────────────────────────
function AdminSettings() {
  const [settings,setSettings]=useState({});
  const [disps,setDisps]=useState([]);
  const [newDisp,setNewDisp]=useState({code:'',label:'',category:'recent'});
  useEffect(()=>{
    api('misc.php?type=settings&action=all').then(r=>{if(r.status==='success')setSettings(r.data);});
    api('misc.php?type=dispositions&action=list').then(r=>{if(r.status==='success')setDisps(r.data);});
  },[]);
  const save=async()=>{const r=await api('misc.php?type=settings&action=update','POST',settings);if(r.status==='success')toast('Settings saved!');else toast(r.message,'error');};
  const addDisp=async()=>{
    if(!newDisp.code||!newDisp.label)return toast('Code and label required','error');
    await api('misc.php?type=dispositions&action=create','POST',{...newDisp,code:newDisp.code.toUpperCase()});
    toast('Disposition added');
    api('misc.php?type=dispositions&action=list').then(r=>{if(r.status==='success')setDisps(r.data);});
    setNewDisp({code:'',label:'',category:'recent'});
  };
  const u=(k,v)=>setSettings(p=>({...p,[k]:v}));
  return(
    <div className="g2">
      <Card>
        <CT icon="⚙️">System Settings</CT>
        <Inp label="Office Hours Start" type="time" value={settings.office_start||''} onChange={e=>u('office_start',e.target.value)}/>
        <Inp label="Office Hours End" type="time" value={settings.office_end||''} onChange={e=>u('office_end',e.target.value)}/>
        <Inp label="Default Daily Target (conversions)" type="number" value={settings.default_daily_target||''} onChange={e=>u('default_daily_target',e.target.value)}/>
        <Inp label="Google Sheet Webhook URL" value={settings.google_sheet_url||''} onChange={e=>u('google_sheet_url',e.target.value)} placeholder="https://script.google.com/..."/>
        <Btn color="green" full onClick={save}>Save Settings</Btn>
      </Card>
      <Card>
        <CT icon="📝">Disposition Codes</CT>
        {disps.map(d=>(
          <div key={d.id} style={{display:'flex',alignItems:'center',gap:10,padding:'9px 0',borderBottom:'1px solid var(--border)'}}>
            <Badge color="green">{d.code}</Badge>
            <span style={{flex:1,fontSize:13}}>{d.label}</span>
            <Badge color="gray">{d.category}</Badge>
            <Btn size="sm" color="ghost" onClick={async()=>{await api('misc.php?type=dispositions&action=toggle','PUT',{id:d.id,is_active:d.is_active?0:1});api('misc.php?type=dispositions&action=list').then(r=>{if(r.status==='success')setDisps(r.data);});}}>{d.is_active?'Disable':'Enable'}</Btn>
          </div>
        ))}
        <div style={{display:'flex',gap:8,marginTop:16,flexWrap:'wrap'}}>
          <input className="inp" value={newDisp.code} onChange={e=>setNewDisp({...newDisp,code:e.target.value})} placeholder="Code" style={{width:70}}/>
          <input className="inp" value={newDisp.label} onChange={e=>setNewDisp({...newDisp,label:e.target.value})} placeholder="Label" style={{flex:1}}/>
          <select className="sel" value={newDisp.category} onChange={e=>setNewDisp({...newDisp,category:e.target.value})} style={{width:120}}>
            <option value="recent">Recent</option><option value="followup">Follow Up</option><option value="converted">Converted</option>
          </select>
          <Btn color="green" onClick={addDisp}>Add</Btn>
        </div>
      </Card>
    </div>
  );
}

// ─── TL DASHBOARD ──────────────────────────────────────────────────────────
function TLDashboard({ user }) {
  const [stats,setStats]=useState(null);
  const [callers,setCallers]=useState([]);
  const load=useCallback(async()=>{
    const [sr,cr]=await Promise.all([api('reports.php?action=tl_dashboard'),api('users.php?action=live_status')]);
    if(sr.status==='success')setStats(sr.data);
    if(cr.status==='success')setCallers(cr.data);
  },[]);
  useEffect(()=>{load();const t=setInterval(load,30000);return()=>clearInterval(t);},[load]);
  const s=stats?.stats||{};
  const sInfo={active:{dot:'dot-green',badge:'green',label:'Active'},break:{dot:'dot-yellow',badge:'gold',label:'On Break'},idle:{dot:'dot-red',badge:'red',label:'Idle'},offline:{dot:'dot-gray',badge:'gray',label:'Offline'}};
  return(
    <>
      <div className="stat-grid-4">
        <StatCard val={s.fresh_available||0} label="Fresh Available" icon="🌱" bg="rgba(45,106,79,0.1)" ac="linear-gradient(90deg,var(--green),var(--green2))"/>
        <StatCard val={s.fresh_assigned||0} label="Fresh Assigned" icon="📤" bg="rgba(43,125,233,0.1)" ac="linear-gradient(90deg,#2b7de9,#64a8f0)"/>
        <StatCard val={s.converted||0} label="Total Converted" icon="✅" bg="rgba(201,168,76,0.1)" ac="linear-gradient(90deg,var(--gold),var(--gold2))"/>
        <StatCard val={stats?.missed_followups||0} label="Missed Follow Ups" icon="⚠️" bg="rgba(193,18,31,0.08)" ac="linear-gradient(90deg,var(--red),#e63946)"/>
      </div>
      <Card>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
          <CT icon="👁️">Team Live Status</CT>
          <Btn color="ghost" size="sm" onClick={load}>↻ Refresh</Btn>
        </div>
        {callers.length?(
          <table className="tbl">
            <thead><tr><th>Caller</th><th>Status</th><th>Today's Calls</th><th>Last Attempt</th><th>Idle (min)</th></tr></thead>
            <tbody>{callers.map(c=>{
              const idle=parseInt(c.idle_minutes)||0;
              const info=sInfo[c.status]||sInfo.offline;
              return(
                <tr key={c.id}>
                  <td style={{fontWeight:600}}>{c.name}</td>
                  <td><span className={`dot ${info.dot}`} style={{marginRight:6}}/><Badge color={info.badge}>{info.label}</Badge></td>
                  <td style={{fontWeight:700,color:'var(--green)'}}>{c.today_attempts||0}</td>
                  <td style={{color:'var(--text3)',fontSize:12,fontFamily:'JetBrains Mono,monospace'}}>{c.last_attempt?.slice(11,16)||'—'}</td>
                  <td style={{fontWeight:700,color:idle>20?'var(--red)':idle>10?'#e9c46a':'var(--green)'}}>{idle}</td>
                </tr>
              );
            })}</tbody>
          </table>
        ):<Empty title="No callers in your team"/>}
      </Card>
    </>
  );
}

// ─── TL CALLERS ────────────────────────────────────────────────────────────
function TLCallers({ user }) {
  const [callers,setCallers]=useState([]);
  const [showCreate,setShowCreate]=useState(false);
  const [form,setForm]=useState({name:'',email:'',password:'Pass@1234'});
  const [noteModal,setNoteModal]=useState(null);
  const [note,setNote]=useState('');
  const [targets,setTargets]=useState({});
  const [editTarget,setEditTarget]=useState(null);
  const [targetVal,setTargetVal]=useState(5);
  const [editUser,setEditUser]=useState(null);
  const [editForm,setEditForm]=useState({});

  const load=async()=>{
    const r=await api('users.php?action=list');
    if(r.status==='success')setCallers(r.data.filter(c=>c.role==='caller'&&String(c.tl_id)===String(user.id)));
    const tr=await api('users.php?action=get_targets');
    if(tr.status==='success'){const t={};tr.data.forEach(x=>t[x.id]=x.daily_target);setTargets(t);}
  };
  useEffect(()=>{load();},[]);

  const create=async()=>{const r=await api('users.php?action=create','POST',{...form,role:'caller'});if(r.status==='success'){toast('Caller created! Password: '+form.password);setShowCreate(false);setForm({name:'',email:'',password:'Pass@1234'});load();}else toast(r.message,'error');};
  const openNote=async c=>{setNoteModal(c);const r=await api(`users.php?action=get_note&caller_id=${c.id}`);if(r.status==='success')setNote(r.data.note);};
  const saveNote=async()=>{await api('users.php?action=save_note','POST',{caller_id:noteModal.id,note});toast('Note saved');setNoteModal(null);};
  const saveTarget=async()=>{const r=await api('users.php?action=set_target','POST',{caller_id:editTarget,target:targetVal});if(r.status==='success'){toast('Target set!');setEditTarget(null);load();}};

  return(
    <>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
        <div style={{color:'var(--text2)'}}>{callers.length} callers in your team</div>
        <Btn color="green" onClick={()=>setShowCreate(true)}>+ Add Caller</Btn>
      </div>
      <Card>
        {callers.length?(
          <table className="tbl">
            <thead><tr><th>Name</th><th>Email</th><th>Today's Target</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>{callers.map(c=>(
              <tr key={c.id}>
                <td style={{fontWeight:600}}>{c.name}</td>
                <td style={{color:'var(--text3)',fontSize:12}}>{c.email}</td>
                <td>
                  <span style={{fontWeight:700,color:'var(--gold)',fontSize:16}}>{targets[c.id]||5}</span>
                  <Btn size="sm" color="ghost" style={{marginLeft:8}} onClick={()=>{setEditTarget(c.id);setTargetVal(targets[c.id]||5);}}>Set</Btn>
                </td>
                <td><Badge color={c.is_active?'green':'red'}>{c.is_active?'Active':'Inactive'}</Badge></td>
                <td>
                  <div style={{display:'flex',gap:6}}>
                    <Btn size="sm" color="ghost" onClick={()=>{setEditUser(c);setEditForm({name:c.name,email:c.email});}}>Edit</Btn>
                    <Btn size="sm" color="ghost" onClick={()=>openNote(c)}>📝 Note</Btn>
                    <Btn size="sm" color={c.is_active?'red':'green'} onClick={async()=>{await api('users.php?action=update','PUT',{id:c.id,is_active:c.is_active?0:1});load();}}>{c.is_active?'Deactivate':'Activate'}</Btn>
                    <Btn size="sm" color="red" onClick={async()=>{if(!window.confirm(`Delete ${c.name}?`))return;const r=await api('users.php?action=delete','DELETE',{id:c.id});if(r.status==='success'){toast('Deleted');load();}else toast(r.message,'error');}}>Del</Btn>
                  </div>
                </td>
              </tr>
            ))}</tbody>
          </table>
        ):<Empty title="No callers yet" desc="Add your first caller"/>}
      </Card>
      <div className={`modal-bg${showCreate?' open':''}`} onClick={e=>e.target===e.currentTarget&&setShowCreate(false)}>
        <div className="modal">
          <div className="modal-title">Add New Caller</div>
          <Inp label="Full Name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})}/>
          <Inp label="Email Address" type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})}/>
          <PasswordInput label="Password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})}/>
          <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}><Btn color="ghost" onClick={()=>setShowCreate(false)}>Cancel</Btn><Btn color="green" onClick={create}>Create Caller</Btn></div>
        </div>
      </div>
      <div className={`modal-bg${editUser?' open':''}`} onClick={e=>e.target===e.currentTarget&&setEditUser(null)}>
        <div className="modal">
          <div className="modal-title">Edit: {editUser?.name}</div>
          <Inp label="Full Name" value={editForm.name||''} onChange={e=>setEditForm({...editForm,name:e.target.value})}/>
          <Inp label="Email" value={editForm.email||''} onChange={e=>setEditForm({...editForm,email:e.target.value})}/>
          <PasswordInput label="New Password (blank = keep)" value={editForm.password||''} onChange={e=>setEditForm({...editForm,password:e.target.value})}/>
          <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}><Btn color="ghost" onClick={()=>setEditUser(null)}>Cancel</Btn><Btn color="green" onClick={async()=>{const pl={id:editUser.id,...editForm};if(!editForm.password)delete pl.password;const r=await api('users.php?action=update','PUT',pl);if(r.status==='success'){toast('Updated!');setEditUser(null);load();}else toast(r.message,'error');}}>Save</Btn></div>
        </div>
      </div>
      <div className={`modal-bg${noteModal?' open':''}`} onClick={e=>e.target===e.currentTarget&&setNoteModal(null)}>
        <div className="modal">
          <div className="modal-title">📝 Private Note — {noteModal?.name}</div>
          <TA label="Note (only you can see this)" value={note} onChange={e=>setNote(e.target.value)} rows={6}/>
          <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:16}}><Btn color="ghost" onClick={()=>setNoteModal(null)}>Cancel</Btn><Btn color="green" onClick={saveNote}>Save Note</Btn></div>
        </div>
      </div>
      <div className={`modal-bg${editTarget?' open':''}`} onClick={e=>e.target===e.currentTarget&&setEditTarget(null)}>
        <div className="modal" style={{maxWidth:320}}>
          <div className="modal-title">🎯 Set Daily Target</div>
          <p style={{color:'var(--text3)',fontSize:13,marginBottom:16}}>For: {callers.find(c=>c.id==editTarget)?.name}</p>
          <Inp label="Daily Target (conversions)" type="number" value={targetVal} onChange={e=>setTargetVal(parseInt(e.target.value)||1)} min={1} max={100}/>
          <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:16}}><Btn color="ghost" onClick={()=>setEditTarget(null)}>Cancel</Btn><Btn color="gold" onClick={saveTarget}>Set Target</Btn></div>
        </div>
      </div>
    </>
  );
}

// ─── TL REPORT ────────────────────────────────────────────────────────────
function TLReport({ products }) {
  const [report,setReport]=useState([]);
  const [from,setFrom]=useState(new Date().toISOString().slice(0,8)+'01');
  const [to,setTo]=useState(new Date().toISOString().slice(0,10));
  const [productId,setProductId]=useState('');
  const [copied,setCopied]=useState(false);
  const load=async()=>{const r=await api(`reports.php?action=team&from=${from}&to=${to}&product_id=${productId}`);if(r.status==='success')setReport(r.data);else toast(r.message,'error');};
  const copy=()=>{
    if(!report.length)return;
    const h='Caller\tTotal Calls\tConverted\tFollow Ups\tNot Connected\tPerformance';
    const rows=report.map(r=>`${r.name}\t${r.total_calls}\t${r.converted}\t${r.followups}\t${r.not_connected}\t${r.label}`);
    navigator.clipboard.writeText([h,...rows].join('\n')).then(()=>{setCopied(true);toast('Copied!');setTimeout(()=>setCopied(false),3000);});
  };
  const cMap={green:'tbl-green',yellow:'tbl-yellow',red:'tbl-red'};
  const bMap={green:'green',yellow:'gold',red:'red'};
  return(
    <Card>
      <CT icon="📊">Team Performance Report</CT>
      <div style={{display:'flex',gap:12,marginBottom:20,flexWrap:'wrap',alignItems:'flex-end'}}>
        <div><label className="flabel">From</label><input className="inp" type="date" value={from} onChange={e=>setFrom(e.target.value)} style={{width:160}}/></div>
        <div><label className="flabel">To</label><input className="inp" type="date" value={to} onChange={e=>setTo(e.target.value)} style={{width:160}}/></div>
        <Sel label="Product" value={productId} onChange={e=>setProductId(e.target.value)} style={{width:180}}>
          <option value="">All Products</option>
          {products.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
        </Sel>
        <Btn color="green" onClick={load}>Show Report</Btn>
        {report.length>0&&<Btn color="ghost" onClick={copy}>{copied?'✅ Copied!':'📋 Copy for Sheet'}</Btn>}
      </div>
      {report.length?(
        <table className="tbl">
          <thead><tr><th>Caller</th><th>Total Calls</th><th>Converted</th><th>Follow Ups</th><th>Not Connected</th><th>Performance</th></tr></thead>
          <tbody>{report.map(r=>(
            <tr key={r.id} className={cMap[r.color]}>
              <td style={{fontWeight:700}}>{r.name}</td>
              <td>{r.total_calls}</td>
              <td style={{fontWeight:800,fontSize:17,color:'var(--green)'}}>{r.converted}</td>
              <td>{r.followups}</td>
              <td>{r.not_connected}</td>
              <td><Badge color={bMap[r.color]}>{r.label}</Badge></td>
            </tr>
          ))}</tbody>
        </table>
      ):<Empty title="Click Show Report to load data"/>}
    </Card>
  );
}

// ─── SHARED: PUNCH MODAL FORM ──────────────────────────────────────────────
function PunchModal({ open, onClose, lead, products, onSuccess }) {
  const [f,setF]=useState({customer_name:'',phone:'',address:'',city:'',product_id:'',quantity:1,price:'',remark:''});
  const [saving,setSaving]=useState(false);
  useEffect(()=>{if(lead)setF(p=>({...p,customer_name:lead.name||'',phone:lead.phone||''}));},[lead]);
  const submit=async()=>{
    if(!f.customer_name||!f.phone||!f.city||!f.product_id||!f.price)return toast('Required fields missing','error');
    setSaving(true);
    const r=await api('punch.php?action=create','POST',{...f,lead_id:lead?.id||null});
    if(r.status==='success'){toast(r.message);onSuccess&&onSuccess();onClose();}else toast(r.message,'error');
    setSaving(false);
  };
  return(
    <div className={`modal-bg${open?' open':''}`} onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal">
        <div className="modal-title">📋 Punch Order{lead&&` — ${lead.name||lead.phone}`}</div>
        <div className="g2"><Inp label="Customer Name*" value={f.customer_name} onChange={e=>setF({...f,customer_name:e.target.value})}/><Inp label="Phone*" value={f.phone} onChange={e=>setF({...f,phone:e.target.value})}/></div>
        <TA label="Address (Optional)" value={f.address} onChange={e=>setF({...f,address:e.target.value})} rows={2}/>
        <div className="g2">
          <Inp label="City*" value={f.city} onChange={e=>setF({...f,city:e.target.value})}/>
          <Sel label="Product*" value={f.product_id} onChange={e=>setF({...f,product_id:e.target.value})}>
            <option value="">-- Select --</option>
            {products.map(p=><option key={p.id} value={p.id}>{p.name} (Min ₹{p.min_price})</option>)}
          </Sel>
        </div>
        <div className="g2">
          <Inp label="Quantity" type="number" value={f.quantity} onChange={e=>setF({...f,quantity:e.target.value})} min={1}/>
          <Inp label="Price (₹)*" type="number" value={f.price} onChange={e=>setF({...f,price:e.target.value})}/>
        </div>
        <TA label="Remark (Optional)" value={f.remark} onChange={e=>setF({...f,remark:e.target.value})} rows={2}/>
        <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:16}}>
          <Btn color="ghost" onClick={onClose}>Cancel</Btn>
          <Btn color="gold" onClick={submit} disabled={saving}>{saving?'Submitting...':'Submit Punch Order'}</Btn>
        </div>
      </div>
    </div>
  );
}

const DISPS=[
  {code:'NC',label:'Not Connected'},{code:'SW',label:'Switch Off'},{code:'BZ',label:'Busy'},
  {code:'NP',label:'Not Picked'},{code:'OFN',label:'Out of Network'},{code:'CB',label:'Call Back'},
  {code:'NI',label:'Not Interested'},{code:'FU',label:'Follow Up'},{code:'CUSTOM',label:'Custom Remark'},
];

function RemarkModal({ open, onClose, lead, onSuccess }) {
  const [disp,setDisp]=useState('');
  const [remark,setRemark]=useState('');
  const [followupAt,setFollowupAt]=useState('');
  const [saving,setSaving]=useState(false);
  useEffect(()=>{if(open){setDisp('');setRemark('');setFollowupAt('');}},[open]);
  const submit=async()=>{
    if(!disp)return toast('Select a disposition','error');
    if(disp==='FU'&&!followupAt)return toast('Follow up date/time required','error');
    setSaving(true);
    const r=await api('leads.php?action=dispose','POST',{lead_id:lead.id,disposition:disp,remark,followup_at:followupAt||null});
    if(r.status==='success'){toast('Saved!');onSuccess&&onSuccess();onClose();}else toast(r.message,'error');
    setSaving(false);
  };
  return(
    <div className={`modal-bg${open?' open':''}`} onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal">
        <div className="modal-title">✏️ Add Remark</div>
        {lead&&<div style={{fontFamily:'JetBrains Mono,monospace',color:'var(--green)',fontWeight:700,fontSize:18,marginBottom:16}}>{lead.phone}</div>}
        <div className="flabel" style={{marginBottom:8}}>Select Disposition</div>
        <div className="disp-grid" style={{marginBottom:16}}>
          {DISPS.map(d=><button key={d.code} className={`disp-btn${disp===d.code?' disp-sel':''}`} onClick={()=>setDisp(d.code)}>{d.label}</button>)}
        </div>
        {disp==='FU'&&<Inp label="Follow Up Date & Time" type="datetime-local" value={followupAt} onChange={e=>setFollowupAt(e.target.value)}/>}
        <TA label="Remark" value={remark} onChange={e=>setRemark(e.target.value)} rows={3}/>
        <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:16}}>
          <Btn color="ghost" onClick={onClose}>Cancel</Btn>
          <Btn color="green" onClick={submit} disabled={saving||!disp}>{saving?'Saving...':'Save Remark'}</Btn>
        </div>
      </div>
    </div>
  );
}

// ─── FOLLOW UPS ────────────────────────────────────────────────────────────
function FollowUps({ user }) {
  const [leads,setLeads]=useState([]);
  const [loading,setLoading]=useState(true);
  const [reassignModal,setReassignModal]=useState(null);
  const [callers,setCallers]=useState([]);
  const [newCaller,setNewCaller]=useState('');
  const [punchLead,setPunchLead]=useState(null);
  const [remarkLead,setRemarkLead]=useState(null);
  const [products,setProducts]=useState([]);

  const load=async()=>{setLoading(true);const r=await api('leads.php?action=followups');if(r.status==='success')setLeads(r.data);setLoading(false);};
  useEffect(()=>{
    load();
    api('misc.php?type=products&action=list').then(r=>{if(r.status==='success')setProducts(r.data);});
    if(user.role==='tl')api('users.php?action=list').then(r=>{if(r.status==='success')setCallers(r.data.filter(u=>u.role==='caller'));});
  },[user]);

  const reassign=async()=>{
    if(!newCaller)return toast('Select a caller','error');
    const r=await api('leads.php?action=reassign_followup','POST',{lead_id:reassignModal.id,caller_id:newCaller});
    if(r.status==='success'){toast('Reassigned!');setReassignModal(null);load();}else toast(r.message,'error');
  };

  const now=new Date();
  return(
    <>
      <Card>
        <CT icon="📅">Follow Ups {leads.length>0&&<Badge color="gold" style={{marginLeft:8}}>{leads.length}</Badge>}</CT>
        {loading?<Spin/>:leads.length===0?<Empty title="No follow ups scheduled"/>:leads.map(l=>{
          const due=new Date(l.followup_at);
          const overdue=due<now;
          const soon=!overdue&&(due-now)<300000;
          return(
            <div key={l.id} className={`fu-card${overdue?' overdue':soon?' soon':''}`}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
                <div>
                  <div style={{fontWeight:700,fontSize:15}}>{l.name||l.phone}</div>
                  <div style={{fontFamily:'JetBrains Mono,monospace',color:'var(--green)',fontWeight:700,fontSize:17,margin:'4px 0'}}>{l.phone}</div>
                  <div style={{color:'var(--text3)',fontSize:12}}>{l.product_name}</div>
                  {user.role==='tl'&&l.caller_name&&<div style={{color:'var(--text3)',fontSize:12}}>Caller: {l.caller_name}</div>}
                  {l.last_remark&&<div style={{color:'var(--text2)',fontSize:13,marginTop:4,fontStyle:'italic'}}>"{l.last_remark}"</div>}
                </div>
                <div style={{textAlign:'right'}}>
                  <Badge color={overdue?'red':soon?'gold':'green'}>{overdue?'Overdue':soon?'Due Soon':'Upcoming'}</Badge>
                  <div style={{color:'var(--text3)',fontSize:12,marginTop:6,fontFamily:'JetBrains Mono,monospace'}}>{l.followup_at?.slice(0,16)}</div>
                </div>
              </div>
              {user.role==='caller'&&(
                <div style={{display:'flex',gap:8}}>
                  <Btn size="sm" color="gold" onClick={()=>setPunchLead(l)}>📋 Punch Order</Btn>
                  <Btn size="sm" color="ghost" onClick={()=>setRemarkLead(l)}>✏️ Add Remark</Btn>
                </div>
              )}
              {user.role==='tl'&&<Btn size="sm" color="ghost" onClick={()=>setReassignModal(l)}>Reassign to Another Caller</Btn>}
            </div>
          );
        })}
      </Card>
      <PunchModal open={!!punchLead} lead={punchLead} products={products} onClose={()=>setPunchLead(null)} onSuccess={load}/>
      <RemarkModal open={!!remarkLead} lead={remarkLead} onClose={()=>setRemarkLead(null)} onSuccess={load}/>
      <div className={`modal-bg${reassignModal?' open':''}`} onClick={e=>e.target===e.currentTarget&&setReassignModal(null)}>
        <div className="modal">
          <div className="modal-title">Reassign Follow Up</div>
          <p style={{color:'var(--text3)',fontSize:13,marginBottom:16}}>{reassignModal?.name||reassignModal?.phone}</p>
          <Sel label="Assign to Caller" value={newCaller} onChange={e=>setNewCaller(e.target.value)}>
            <option value="">-- Select Caller --</option>
            {callers.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
          </Sel>
          <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:16}}>
            <Btn color="ghost" onClick={()=>setReassignModal(null)}>Cancel</Btn>
            <Btn color="gold" onClick={reassign}>Reassign</Btn>
          </div>
        </div>
      </div>
    </>
  );
}

// ─── MESSAGES ─────────────────────────────────────────────────────────────
function Messages({ user }) {
  const [msgs,setMsgs]=useState([]);
  const [callers,setCallers]=useState([]);
  const [msg,setMsg]=useState('');
  const [toId,setToId]=useState('');
  const [broadcast,setBroadcast]=useState(false);
  const loadMsgs=async()=>{const r=await api('misc.php?type=messages&action=inbox');if(r.status==='success')setMsgs(r.data);};
  useEffect(()=>{
    loadMsgs();
    if(user.role!=='caller')api('users.php?action=list').then(r=>{if(r.status==='success')setCallers(r.data.filter(u=>u.role==='caller'&&(user.role==='admin'||String(u.tl_id)===String(user.id))));});
  },[user]);
  const send=async()=>{
    if(!msg.trim())return toast('Enter a message','error');
    const r=await api('misc.php?type=messages&action=send','POST',{to_id:broadcast?null:toId||null,message:msg,is_broadcast:broadcast?1:0});
    if(r.status==='success'){toast('Message sent!');setMsg('');loadMsgs();}else toast(r.message,'error');
  };
  const del=async id=>{await api('misc.php?type=messages&action=delete','DELETE',{id});loadMsgs();};
  return(
    <>
      {user.role!=='caller'&&(
        <Card>
          <CT icon="📤">Send Message</CT>
          <label style={{display:'flex',alignItems:'center',gap:8,color:'var(--text2)',fontSize:13,cursor:'pointer',marginBottom:14}}>
            <input type="checkbox" checked={broadcast} onChange={e=>setBroadcast(e.target.checked)}/>Broadcast to entire team
          </label>
          {!broadcast&&(
            <Sel label="Select Recipient" value={toId} onChange={e=>setToId(e.target.value)}>
              <option value="">-- Select Caller --</option>
              {callers.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
            </Sel>
          )}
          <div style={{display:'flex',gap:10}}>
            <input className="inp" value={msg} onChange={e=>setMsg(e.target.value)} placeholder="Type your message..." style={{flex:1}} onKeyDown={e=>e.key==='Enter'&&send()}/>
            <Btn color="green" onClick={send}>Send</Btn>
          </div>
        </Card>
      )}
      <Card>
        <CT icon="📥">Inbox</CT>
        {msgs.length===0?<Empty title="No messages"/>:msgs.map(m=>(
          <div key={m.id} className={`msg-item${!m.is_read?' unread':''}`}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
              <div style={{fontWeight:700,color:'var(--green)',marginBottom:4}}>{m.from_name}{m.is_broadcast?' (Broadcast)':''}</div>
              <button onClick={()=>del(m.id)} style={{background:'none',color:'var(--text3)',fontSize:14,cursor:'pointer',border:'none',padding:4}}>✕</button>
            </div>
            <div style={{fontSize:13,lineHeight:1.6}}>{m.message}</div>
            <div style={{color:'var(--text3)',fontSize:11,marginTop:5,fontFamily:'JetBrains Mono,monospace'}}>{m.created_at?.slice(0,16)}</div>
          </div>
        ))}
      </Card>
    </>
  );
}

// ─── CALLING SCREEN ────────────────────────────────────────────────────────
function CallingScreen({ user }) {
  const [lead,setLead]=useState(null);
  const [loading,setLoading]=useState(true);
  const [disp,setDisp]=useState('');
  const [remark,setRemark]=useState('');
  const [followupAt,setFollowupAt]=useState('');
  const [submitting,setSubmitting]=useState(false);
  const [showScript,setShowScript]=useState(false);
  const [showPunch,setShowPunch]=useState(false);
  const [products,setProducts]=useState([]);
  const [todayStats,setTodayStats]=useState(null);
  const [tab,setTab]=useState('fresh');
  const [freshLeads,setFreshLeads]=useState([]);
  const [recentLeads,setRecentLeads]=useState([]);
  const [listLoading,setListLoading]=useState(false);

  const loadLeads=useCallback(async()=>{
    setListLoading(true);
    const nowIST=new Date(Date.now()+(5.5*60*60*1000));
    const todayIST=nowIST.toISOString().slice(0,10);
    const notToday=l=>!l.last_attempt_at||l.last_attempt_at.slice(0,10)!==todayIST;
    const [fr,re]=await Promise.all([api('leads.php?action=my_leads&pool=fresh'),api('leads.php?action=my_leads&pool=recent')]);
    if(fr.status==='success')setFreshLeads(fr.data.filter(notToday));
    if(re.status==='success')setRecentLeads(re.data.filter(notToday));
    setListLoading(false);
  },[]);

  const fetchLead=useCallback(async(id=null)=>{
    setLoading(true);
    const r=id?await api(`leads.php?action=get_lead&id=${id}`):await api('leads.php?action=next');
    if(r.status==='success')setLead(r.data?.lead!==undefined?r.data.lead:r.data);
    else setLead(null);
    setLoading(false);
    setDisp('');setRemark('');setFollowupAt('');setShowScript(false);
  },[]);

  const refreshStats=()=>api('reports.php?action=personal').then(r=>{if(r.status==='success')setTodayStats(r.data);});

  useEffect(()=>{
    fetchLead();loadLeads();
    api('misc.php?type=products&action=list').then(r=>{if(r.status==='success')setProducts(r.data);});
    refreshStats();
  },[fetchLead,loadLeads]);

  const submit=async()=>{
    if(!disp)return toast('Select a disposition','error');
    if(disp==='FU'&&!followupAt)return toast('Follow up date/time required','error');
    setSubmitting(true);
    const doneId=lead.id;
    const r=await api('leads.php?action=dispose','POST',{lead_id:lead.id,disposition:disp,remark,followup_at:followupAt||null});
    if(r.status==='success'){
      toast('Saved!');
      setFreshLeads(prev=>prev.filter(l=>l.id!==doneId));
      setRecentLeads(prev=>prev.filter(l=>l.id!==doneId));
      fetchLead();refreshStats();
    }else toast(r.message,'error');
    setSubmitting(false);
  };

  const blacklist=async()=>{
    if(!window.confirm(`Blacklist ${lead.phone}?`))return;
    const r=await api('misc.php?type=blacklist&action=add','POST',{phones:[lead.phone],reason:'Blacklisted from calling screen',force:true});
    if(r.status==='success'){toast('Blacklisted!');const doneId=lead.id;setFreshLeads(prev=>prev.filter(l=>l.id!==doneId));setRecentLeads(prev=>prev.filter(l=>l.id!==doneId));fetchLead();}
    else toast(r.message,'error');
  };

  const target=todayStats?.daily_target||5;
  const converted=todayStats?.today?.converted||0;
  const progress=Math.min(100,Math.round(converted/target*100));
  const currentList=tab==='fresh'?freshLeads:recentLeads;

  return(
    <div style={{display:'flex',gap:20,alignItems:'flex-start'}}>
      {/* Left Panel */}
      <div style={{width:270,flexShrink:0}}>
        <Card style={{marginBottom:0}}>
          <div className="tabs" style={{marginBottom:12}}>
            <button className={`tab${tab==='fresh'?' active':''}`} onClick={()=>setTab('fresh')}>🌱 Fresh <span style={{fontSize:11,opacity:.7,marginLeft:4}}>{freshLeads.length}</span></button>
            <button className={`tab${tab==='recent'?' active':''}`} onClick={()=>setTab('recent')}>🔄 Recent <span style={{fontSize:11,opacity:.7,marginLeft:4}}>{recentLeads.length}</span></button>
          </div>
          {listLoading?<Spin/>:currentList.length===0?(
            <div style={{textAlign:'center',padding:'28px 16px',color:'var(--text3)'}}>
              <div style={{fontSize:28,marginBottom:8}}>✅</div>
              <div style={{fontWeight:600}}>All {tab} leads done</div>
            </div>
          ):currentList.map(l=>(
            <div key={l.id} onClick={()=>fetchLead(l.id)} className={`lead-list-item${lead?.id===l.id?' sel':''}`}>
              <div style={{fontWeight:700,fontSize:13}}>{l.name||'Unknown'}</div>
              <div style={{fontFamily:'JetBrains Mono,monospace',color:'var(--green)',fontWeight:700,fontSize:14}}>{l.phone}</div>
              <div style={{marginTop:4}}><Badge color="green" style={{fontSize:10}}>{l.product_name}</Badge></div>
              {l.last_remark&&<div style={{fontSize:11,color:'var(--text3)',marginTop:3,fontStyle:'italic',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>"{l.last_remark}"</div>}
            </div>
          ))}
          <Btn color="ghost" size="sm" style={{width:'100%',marginTop:10}} onClick={()=>{fetchLead();loadLeads();}}>↻ Refresh</Btn>
        </Card>
      </div>

      {/* Right Panel */}
      <div style={{flex:1}}>
        {todayStats&&(
          <Card style={{marginBottom:16}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:8}}>
              <span style={{fontWeight:600,color:'var(--text2)'}}>Today's Progress</span>
              <span style={{fontWeight:800,color:progress>=100?'var(--green)':progress>=60?'var(--gold)':'var(--red)'}}>{converted}/{target} ({progress}%)</span>
            </div>
            <div className="prog-wrap"><div className="prog-bar" style={{width:`${progress}%`,background:progress>=100?'linear-gradient(90deg,var(--green),var(--green2))':progress>=60?'linear-gradient(90deg,var(--gold),var(--gold2))':'linear-gradient(90deg,var(--red),#e63946)'}}/></div>
            {progress>=100&&<div style={{textAlign:'center',color:'var(--green)',fontWeight:700,marginTop:8}}>🎉 Target achieved today!</div>}
          </Card>
        )}

        {loading?<Spin/>:!lead?(
          <Card>
            <div style={{textAlign:'center',padding:'44px 20px'}}>
              <div style={{fontSize:52,marginBottom:16}}>✅</div>
              <h2 style={{fontFamily:'Playfair Display,serif',color:'var(--green)',marginBottom:8,fontSize:22}}>You're all caught up!</h2>
              <p style={{color:'var(--text2)',fontSize:15,marginBottom:6}}>No pending leads at the moment.</p>
              <p style={{color:'var(--text3)',fontSize:13,marginBottom:28}}>Contact your Team Lead to get more leads assigned.</p>
              <Btn color="green" onClick={()=>{fetchLead();loadLeads();}}>↻ Refresh</Btn>
            </div>
          </Card>
        ):(
          <>
            <div className="lead-hero">
              <div className="lead-pending-badge">{lead.pending||0} pending</div>
              <div style={{fontSize:11,opacity:.5,textTransform:'uppercase',letterSpacing:1}}>{lead.product_name}</div>
              <div style={{fontSize:18,fontWeight:600,marginTop:4}}>{lead.name||'Unknown Customer'}</div>
              <div className="lead-phone">{lead.phone}</div>
              {lead.last_disposition&&(
                <div style={{display:'flex',gap:10,alignItems:'center',marginTop:8,flexWrap:'wrap'}}>
                  <Badge color="gray">Last: {lead.last_disposition}</Badge>
                  {lead.last_remark&&<span style={{opacity:.7,fontSize:12}}>"{lead.last_remark}"</span>}
                </div>
              )}
              <div style={{display:'flex',gap:10,marginTop:14,flexWrap:'wrap'}}>
                {lead.script&&<button onClick={()=>setShowScript(!showScript)} style={{background:'rgba(255,255,255,0.12)',border:'1px solid rgba(255,255,255,0.2)',borderRadius:6,padding:'6px 14px',color:'#fff',fontSize:12,cursor:'pointer'}}>{showScript?'▲ Hide Script':'▼ Show Script'}</button>}
                <button onClick={blacklist} style={{background:'rgba(193,18,31,0.2)',border:'1px solid rgba(193,18,31,0.3)',borderRadius:6,padding:'6px 14px',color:'#f88',fontSize:12,cursor:'pointer'}}>🚫 Blacklist</button>
              </div>
              {showScript&&lead.script&&<div style={{marginTop:14,background:'rgba(0,0,0,0.2)',borderRadius:8,padding:14,fontSize:13,lineHeight:1.7,whiteSpace:'pre-wrap'}}>{lead.script}</div>}
            </div>

            {lead.history?.length>0&&(
              <Card style={{marginBottom:16}}>
                <CT icon="📋">Previous Calls</CT>
                {lead.history.map((h,i)=>(
                  <div key={i} className="hist-item">
                    <span className="hist-time">{h.attempted_at?.slice(0,16)}</span>
                    <Badge color={h.disposition==='CONV'?'green':h.disposition==='FU'?'gold':'gray'}>{h.disposition}</Badge>
                    <div style={{flex:1}}>{h.remark&&<div style={{fontSize:13}}>{h.remark}</div>}<div style={{color:'var(--text3)',fontSize:11,marginTop:2}}>by {h.by_name}</div></div>
                  </div>
                ))}
              </Card>
            )}

            <Card>
              <CT icon="📝">Disposition</CT>
              <div className="disp-grid">
                {DISPS.map(d=><button key={d.code} className={`disp-btn${disp===d.code?(d.code==='FU'?' disp-sel-gold':' disp-sel'):''}`} onClick={()=>setDisp(d.code)}>{d.label}</button>)}
              </div>
              {disp==='FU'&&<Inp label="Follow Up Date & Time" type="datetime-local" value={followupAt} onChange={e=>setFollowupAt(e.target.value)}/>}
              <TA label="Remark (optional)" value={remark} onChange={e=>setRemark(e.target.value)} rows={3} placeholder="Add notes about this call..."/>
              <div style={{display:'flex',gap:10,marginTop:4}}>
                <Btn color={disp?'green':'ghost'} full onClick={submit} disabled={submitting||!disp}>{submitting?'Saving...':'Submit Remark'}</Btn>
                <Btn color="gold" onClick={()=>setShowPunch(true)}>📋 Punch</Btn>
              </div>
            </Card>
          </>
        )}
      </div>
      <PunchModal open={showPunch} lead={lead} products={products} onClose={()=>setShowPunch(false)} onSuccess={()=>{const doneId=lead?.id;if(doneId){setFreshLeads(prev=>prev.filter(l=>l.id!==doneId));setRecentLeads(prev=>prev.filter(l=>l.id!==doneId));}fetchLead();refreshStats();}}/>
    </div>
  );
}

// ─── MY PUNCHES ────────────────────────────────────────────────────────────
function MyPunches() {
  const [punches,setPunches]=useState([]);
  const [loading,setLoading]=useState(true);
  const [showCustom,setShowCustom]=useState(false);
  const [customForm,setCustomForm]=useState({customer_name:'',phone:'',address:'',city:'',product_id:'',quantity:1,price:'',remark:''});
  const [products,setProducts]=useState([]);
  const [punching,setPunching]=useState(false);
  const [from,setFrom]=useState(()=>new Date().toISOString().slice(0,8)+'01');
  const [to,setTo]=useState(()=>new Date().toISOString().slice(0,10));

  const load=useCallback(async()=>{setLoading(true);const r=await api(`punch.php?action=my_punches&from=${from}&to=${to}`);if(r.status==='success')setPunches(r.data);setLoading(false);},[from,to]);
  useEffect(()=>{load();api('misc.php?type=products&action=list').then(r=>{if(r.status==='success')setProducts(r.data);});},[load]);

  const submitCustom=async()=>{
    if(!customForm.customer_name||!customForm.phone||!customForm.city||!customForm.product_id||!customForm.price)return toast('Required fields missing','error');
    setPunching(true);
    const r=await api('punch.php?action=custom','POST',customForm);
    if(r.status==='success'){toast(r.message);setShowCustom(false);setCustomForm({customer_name:'',phone:'',address:'',city:'',product_id:'',quantity:1,price:'',remark:''});load();}
    else toast(r.message,'error');
    setPunching(false);
  };

  const repunch=async id=>{const r=await api('punch.php?action=repunch','POST',{punch_id:id});if(r.status==='success'){toast('Repunched to Sheet!');load();}else toast(r.message,'error');};
  const cancel=async id=>{if(!window.confirm('Cancel this punch order?'))return;const r=await api('punch.php?action=cancel','POST',{punch_id:id});if(r.status==='success'){toast('Cancelled','info');load();}else toast(r.message,'error');};
  const markConv=async p=>{const r=await api('leads.php?action=mark_converted','POST',{lead_id:p.lead_id});if(r.status==='success'){toast('Marked as converted!');load();}else toast(r.message,'error');};
  const deletePunch=async id=>{if(!window.confirm('Delete this punch permanently?'))return;const r=await api('punch.php?action=delete_punch','DELETE',{punch_id:id});if(r.status==='success'){toast('Deleted','info');load();}else toast(r.message,'error');};

  const sColor={pending:'gold',synced:'blue',cancelled:'gray',converted:'green'};
  const totalAmt=punches.filter(p=>p.status!=='cancelled').reduce((s,p)=>s+parseFloat(p.price||0),0);
  const totalOrders=punches.filter(p=>p.status!=='cancelled').length;

  return(
    <>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-end',marginBottom:16,flexWrap:'wrap',gap:10}}>
        <div style={{display:'flex',gap:10,alignItems:'flex-end',flexWrap:'wrap'}}>
          <div><label className="flabel">From</label><input className="inp" type="date" value={from} onChange={e=>setFrom(e.target.value)} style={{width:150}}/></div>
          <div><label className="flabel">To</label><input className="inp" type="date" value={to} onChange={e=>setTo(e.target.value)} style={{width:150}}/></div>
          <Btn color="green" onClick={load}>Filter</Btn>
        </div>
        <Btn color="gold" onClick={()=>setShowCustom(true)}>📋 Custom / Verbal Punch</Btn>
      </div>
      {punches.length>0&&(
        <div style={{display:'flex',gap:16,marginBottom:16}}>
          <div style={{background:'rgba(45,106,79,0.08)',border:'1px solid rgba(45,106,79,0.2)',borderRadius:'var(--r-sm)',padding:'10px 18px'}}>
            <div style={{fontSize:11,color:'var(--text3)',fontWeight:700}}>TOTAL ORDERS</div>
            <div style={{fontFamily:'Playfair Display,serif',fontSize:22,fontWeight:800,color:'var(--green)'}}>{totalOrders}</div>
          </div>
          <div style={{background:'rgba(201,168,76,0.08)',border:'1px solid rgba(201,168,76,0.2)',borderRadius:'var(--r-sm)',padding:'10px 18px'}}>
            <div style={{fontSize:11,color:'var(--text3)',fontWeight:700}}>TOTAL AMOUNT</div>
            <div style={{fontFamily:'Playfair Display,serif',fontSize:22,fontWeight:800,color:'var(--gold)'}}>₹{totalAmt.toLocaleString('en-IN')}</div>
          </div>
        </div>
      )}
      <Card>
        <CT icon="📋">My Punch Orders</CT>
        {loading?<Spin/>:punches.length===0?<Empty title="No punch orders in this range"/>:punches.map(p=>(
          <div key={p.id} style={{padding:'14px 0',borderBottom:'1px solid var(--border)'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
              <div>
                <div style={{fontWeight:700,fontSize:15}}>{p.customer_name}</div>
                <div style={{fontFamily:'JetBrains Mono,monospace',color:'var(--green)',fontWeight:700,fontSize:14}}>{p.phone}</div>
                <div style={{color:'var(--text3)',fontSize:12,marginTop:2}}>{p.product_name} · Qty {p.quantity} · <strong style={{color:'var(--text)'}}>₹{parseFloat(p.price).toLocaleString('en-IN')}</strong></div>
                {p.city&&<div style={{color:'var(--text3)',fontSize:12}}>📍 {p.city}</div>}
                {p.remark&&<div style={{color:'var(--text2)',fontSize:13,marginTop:2,fontStyle:'italic'}}>{p.remark}</div>}
              </div>
              <div style={{textAlign:'right'}}>
                <Badge color={sColor[p.status]||'gray'}>{p.status}</Badge>
                <div style={{color:'var(--text3)',fontSize:11,marginTop:4,fontFamily:'JetBrains Mono,monospace'}}>{p.created_at?.slice(0,16)}</div>
                {!p.lead_id&&<div style={{marginTop:4}}><Badge color="orange">Verbal</Badge></div>}
              </div>
            </div>
            <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
              {!p.sheet_synced&&p.status==='pending'&&<Btn size="sm" color="gold" onClick={()=>repunch(p.id)}>↻ Repunch</Btn>}
              {p.status==='synced'&&p.lead_id&&<Btn size="sm" color="green" onClick={()=>markConv(p)}>✅ Mark Converted</Btn>}
              {['pending','synced'].includes(p.status)&&<Btn size="sm" color="ghost" onClick={()=>cancel(p.id)}>Cancel</Btn>}
              {p.status==='cancelled'&&<Btn size="sm" color="red" onClick={()=>deletePunch(p.id)}>🗑️ Delete</Btn>}
            </div>
          </div>
        ))}
      </Card>
      <div className={`modal-bg${showCustom?' open':''}`} onClick={e=>e.target===e.currentTarget&&setShowCustom(false)}>
        <div className="modal">
          <div className="modal-title">📋 Custom / Verbal Punch</div>
          <p style={{color:'var(--text3)',fontSize:13,marginBottom:16}}>For orders received verbally or from outside the CRM.</p>
          <div className="g2"><Inp label="Customer Name*" value={customForm.customer_name} onChange={e=>setCustomForm({...customForm,customer_name:e.target.value})}/><Inp label="Phone*" value={customForm.phone} onChange={e=>setCustomForm({...customForm,phone:e.target.value})}/></div>
          <TA label="Address (Optional)" value={customForm.address} onChange={e=>setCustomForm({...customForm,address:e.target.value})} rows={2}/>
          <div className="g2">
            <Inp label="City*" value={customForm.city} onChange={e=>setCustomForm({...customForm,city:e.target.value})}/>
            <Sel label="Product*" value={customForm.product_id} onChange={e=>setCustomForm({...customForm,product_id:e.target.value})}>
              <option value="">-- Select --</option>
              {products.map(p=><option key={p.id} value={p.id}>{p.name} (Min ₹{p.min_price})</option>)}
            </Sel>
          </div>
          <div className="g2"><Inp label="Quantity" type="number" value={customForm.quantity} onChange={e=>setCustomForm({...customForm,quantity:e.target.value})} min={1}/><Inp label="Price (₹)*" type="number" value={customForm.price} onChange={e=>setCustomForm({...customForm,price:e.target.value})}/></div>
          <TA label="Remark (Optional)" value={customForm.remark} onChange={e=>setCustomForm({...customForm,remark:e.target.value})} rows={2}/>
          <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:16}}>
            <Btn color="ghost" onClick={()=>setShowCustom(false)}>Cancel</Btn>
            <Btn color="gold" onClick={submitCustom} disabled={punching}>{punching?'Submitting...':'Submit Custom Punch'}</Btn>
          </div>
        </div>
      </div>
    </>
  );
}

// ─── MY LEADS ─────────────────────────────────────────────────────────────
function MyLeads() {
  const [leads,setLeads]=useState([]);
  const [pool,setPool]=useState('all');
  const [search,setSearch]=useState('');
  const [loading,setLoading]=useState(true);
  const [histModal,setHistModal]=useState(null);
  const [history,setHistory]=useState([]);
  const [punchLead,setPunchLead]=useState(null);
  const [remarkLead,setRemarkLead]=useState(null);
  const [products,setProducts]=useState([]);

  const load=async()=>{setLoading(true);const r=await api(`leads.php?action=my_leads&pool=${pool}&search=${search}`);if(r.status==='success')setLeads(r.data);setLoading(false);};
  useEffect(()=>{load();},[pool,search]);
  useEffect(()=>{api('misc.php?type=products&action=list').then(r=>{if(r.status==='success')setProducts(r.data);});},[]);
  const viewHist=async lid=>{setHistModal(lid);const r=await api(`leads.php?action=history&lead_id=${lid}`);if(r.status==='success')setHistory(r.data);};
  const pColor={fresh:'green',recent:'gold',followup:'orange',converted:'blue'};

  return(
    <>
      <div className="tabs">
        {['all','fresh','recent','followup','converted'].map(p=><button key={p} className={`tab${pool===p?' active':''}`} onClick={()=>setPool(p)} style={{textTransform:'capitalize'}}>{p}</button>)}
      </div>
      <div className="search-bar" style={{marginBottom:16}}>
        <span>🔍</span>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search by name or phone..."/>
        {search&&<button onClick={()=>setSearch('')} style={{background:'none',color:'var(--text3)',border:'none',cursor:'pointer',fontSize:16}}>✕</button>}
      </div>
      <Card>
        <div style={{color:'var(--text3)',fontSize:12,marginBottom:12}}>{leads.length} leads</div>
        {loading?<Spin/>:leads.length===0?<Empty title={`No ${pool==='all'?'':pool} leads`}/>:(
          <div style={{overflowX:'auto'}}>
            <table className="tbl">
              <thead><tr><th>Name</th><th>Phone</th><th>Product</th><th>Status</th><th>Last Status</th><th>Last Remark</th><th>Actions</th></tr></thead>
              <tbody>{leads.map(l=>(
                <tr key={l.id}>
                  <td style={{fontWeight:600}}>{l.name||'—'}</td>
                  <td style={{fontFamily:'JetBrains Mono,monospace',color:'var(--green)',fontWeight:700}}>{l.phone}</td>
                  <td><Badge color="green">{l.product_name}</Badge></td>
                  <td><Badge color={pColor[l.pool]||'gray'}>{l.pool}</Badge></td>
                  <td>{l.last_disposition?<Badge color={l.last_disposition==='CONV'?'green':'gray'}>{l.last_disposition}</Badge>:'—'}</td>
                  <td style={{color:'var(--text3)',fontSize:12,maxWidth:150,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{l.last_remark||'—'}</td>
                  <td>
                    <div style={{display:'flex',gap:4}}>
                      <Btn size="sm" color="ghost" onClick={()=>viewHist(l.id)}>History</Btn>
                      {['recent','followup'].includes(l.pool)&&<Btn size="sm" color="gold" onClick={()=>setPunchLead(l)}>Punch</Btn>}
                      {['recent','followup'].includes(l.pool)&&<Btn size="sm" color="ghost" onClick={()=>setRemarkLead(l)}>Remark</Btn>}
                    </div>
                  </td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        )}
      </Card>
      <div className={`modal-bg${histModal?' open':''}`} onClick={e=>e.target===e.currentTarget&&setHistModal(null)}>
        <div className="modal">
          <div className="modal-title">📋 Call History</div>
          {history.map((h,i)=>(
            <div key={i} className="hist-item">
              <span className="hist-time">{h.attempted_at?.slice(0,16)}</span>
              <Badge color={h.disposition==='CONV'?'green':h.disposition==='FU'?'gold':'gray'}>{h.disposition}</Badge>
              <div style={{flex:1}}>{h.remark&&<div style={{fontSize:13}}>{h.remark}</div>}<div style={{color:'var(--text3)',fontSize:11,marginTop:2}}>by {h.by_name}</div></div>
            </div>
          ))}
          {history.length===0&&<Empty title="No history"/>}
          <div style={{marginTop:20,display:'flex',justifyContent:'flex-end'}}><Btn color="ghost" onClick={()=>setHistModal(null)}>Close</Btn></div>
        </div>
      </div>
      <PunchModal open={!!punchLead} lead={punchLead} products={products} onClose={()=>setPunchLead(null)} onSuccess={load}/>
      <RemarkModal open={!!remarkLead} lead={remarkLead} onClose={()=>setRemarkLead(null)} onSuccess={load}/>
    </>
  );
}

// ─── PERFORMANCE ──────────────────────────────────────────────────────────
function Performance() {
  const [data,setData]=useState(null);
  const [days,setDays]=useState(7);
  const [top,setTop]=useState(null);
  const load=useCallback(async()=>{
    const [r,tr]=await Promise.all([api(`reports.php?action=personal&days=${days}`),api('reports.php?action=top_performer')]);
    if(r.status==='success')setData(r.data);
    if(tr.status==='success')setTop(tr.data);
  },[days]);
  useEffect(()=>{load();},[load]);
  if(!data)return<Spin/>;
  const t=data.today||{};
  const target=data.daily_target||5;
  const converted=t.converted||0;
  const progress=Math.min(100,Math.round(converted/target*100));
  const max=Math.max(...(data.weekly||[]).map(w=>parseInt(w.converted)||0),1);
  return(
    <>
      {top&&top.today_conv>0&&(
        <div style={{background:'linear-gradient(135deg,#1b4332,#2d6a4f)',borderRadius:'var(--r)',padding:'16px 22px',marginBottom:16,display:'flex',alignItems:'center',gap:14,boxShadow:'0 4px 20px rgba(27,67,50,0.3)'}}>
          <span style={{fontSize:30}}>🏆</span>
          <div>
            <div style={{color:'var(--gold2)',fontWeight:700,fontSize:15}}>Top Today: {top.name}</div>
            <div style={{color:'rgba(255,255,255,0.6)',fontSize:13}}>{top.today_conv} conversion{top.today_conv!==1?'s':''} so far today!</div>
          </div>
        </div>
      )}
      <div className="stat-grid-4">
        <StatCard val={converted} label="Today Converted" icon="✅" bg="rgba(45,106,79,0.1)" ac="linear-gradient(90deg,var(--green),var(--green2))"/>
        <StatCard val={target} label="Daily Target" icon="🎯" bg="rgba(201,168,76,0.1)" ac="linear-gradient(90deg,var(--gold),var(--gold2))"/>
        <StatCard val={t.total_attempts||0} label="Today's Calls" icon="📞" bg="rgba(43,125,233,0.1)" ac="linear-gradient(90deg,#2b7de9,#64a8f0)"/>
        <StatCard val={`${data.streak||0}d`} label="Win Streak 🔥" icon="🔥" bg="rgba(231,111,81,0.1)" ac="linear-gradient(90deg,var(--orange),#f4a261)"/>
      </div>
      <Card>
        <CT icon="🎯">Today's Progress</CT>
        <div style={{display:'flex',justifyContent:'space-between',marginBottom:10}}>
          <span style={{color:'var(--text2)',fontWeight:500}}>Progress to Target</span>
          <span style={{fontWeight:800,color:progress>=100?'var(--green)':progress>=60?'var(--gold)':'var(--red)'}}>{converted}/{target} ({progress}%)</span>
        </div>
        <div className="prog-wrap" style={{height:16}}>
          <div className="prog-bar" style={{width:`${progress}%`,background:progress>=100?'linear-gradient(90deg,var(--green),var(--green2))':progress>=60?'linear-gradient(90deg,var(--gold),var(--gold2))':'linear-gradient(90deg,var(--red),#e63946)'}}/>
        </div>
        {progress>=100&&<div style={{marginTop:12,textAlign:'center',color:'var(--green)',fontWeight:700}}>🎉 Target achieved! Keep going!</div>}
      </Card>
      <Card>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
          <CT icon="📈">Performance History</CT>
          <div style={{display:'flex',gap:6}}>
            {[{v:3,l:'3D'},{v:7,l:'7D'},{v:30,l:'30D'},{v:0,l:'All'}].map(d=>(
              <button key={d.v} onClick={()=>setDays(d.v)} style={{padding:'5px 12px',borderRadius:6,border:`1.5px solid ${days===d.v?'var(--green)':'var(--border)'}`,background:days===d.v?'rgba(45,106,79,0.1)':'transparent',color:days===d.v?'var(--green)':'var(--text3)',fontSize:12,fontWeight:600,cursor:'pointer'}}>{d.l}</button>
            ))}
          </div>
        </div>
        {(data.weekly||[]).length?(
          <div style={{display:'flex',alignItems:'flex-end',gap:8,height:140,padding:'0 4px'}}>
            {data.weekly.map((w,i)=>{
              const h=Math.max(6,Math.round((parseInt(w.converted)||0)/max*120));
              return(
                <div key={i} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',gap:4}}>
                  <span style={{fontSize:11,fontWeight:700,color:'var(--green)'}}>{w.converted}</span>
                  <div style={{width:'100%',height:`${h}px`,background:'linear-gradient(0deg,var(--green),var(--green2))',borderRadius:'4px 4px 0 0'}}/>
                  <span style={{fontSize:10,color:'var(--text3)'}}>{w.date?.slice(5)}</span>
                </div>
              );
            })}
          </div>
        ):<Empty title="No data in selected range"/>}
      </Card>
    </>
  );
}

// ─── LEADERBOARD ──────────────────────────────────────────────────────────
function Leaderboard() {
  const [board,setBoard]=useState([]);
  useEffect(()=>{api('reports.php?action=leaderboard').then(r=>{if(r.status==='success')setBoard(r.data);});},[]);
  const medals=['🥇','🥈','🥉'];
  return(
    <Card>
      <CT icon="🥇">Team Leaderboard — Today</CT>
      {board.length===0?<Empty title="No data yet today"/>:board.map((c,i)=>(
        <div key={c.id} className={`lb-row${c.is_me?' lb-me':''}`}>
          <span style={{fontSize:22,width:36,textAlign:'center',flexShrink:0}}>{medals[i]||`${i+1}`}</span>
          <div style={{flex:1}}>
            <div style={{fontWeight:700,display:'flex',alignItems:'center',gap:8}}>{c.name}{c.is_me&&<Badge color="green">You</Badge>}</div>
            <div style={{color:'var(--text3)',fontSize:12}}>Total: {c.total_conv}</div>
          </div>
          <div style={{textAlign:'right'}}>
            <div style={{fontFamily:'Playfair Display,serif',fontSize:28,fontWeight:800,color:i===0?'var(--gold)':'var(--green)'}}>{c.today_conv}</div>
            <div style={{color:'var(--text3)',fontSize:11}}>today</div>
          </div>
        </div>
      ))}
    </Card>
  );
}

// ─── SEARCH LEAD ──────────────────────────────────────────────────────────
function SearchLead() {
  const [phone,setPhone]=useState('');
  const [results,setResults]=useState([]);
  const [loading,setLoading]=useState(false);
  const [searched,setSearched]=useState(false);
  const search=async()=>{
    if(!phone.trim())return toast('Enter a phone number','error');
    setLoading(true);
    const r=await api(`leads.php?action=search&phone=${phone.trim()}`);
    if(r.status==='success'){setResults(r.data);setSearched(true);}else toast(r.message,'error');
    setLoading(false);
  };
  const pColor={fresh:'green',recent:'gold',followup:'orange',converted:'blue'};
  return(
    <Card>
      <CT icon="🔍">Search Lead by Phone</CT>
      <div style={{display:'flex',gap:12,marginBottom:20}}>
        <input className="inp" value={phone} onChange={e=>setPhone(e.target.value)} placeholder="Enter phone number..." style={{flex:1}} onKeyDown={e=>e.key==='Enter'&&search()}/>
        <Btn color="green" onClick={search} disabled={loading}>{loading?'Searching...':'Search'}</Btn>
      </div>
      {searched&&(results.length===0?<Empty title="No leads found" desc="This number is not in the system"/>:results.map((l,i)=>(
        <div key={i} style={{padding:'16px 18px',border:'1px solid var(--border)',borderRadius:'var(--r)',marginBottom:10}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
            <div>
              <div style={{fontWeight:700,fontSize:16}}>{l.name||'Unknown'}</div>
              <div style={{fontFamily:'JetBrains Mono,monospace',color:'var(--green)',fontWeight:700,fontSize:18}}>{l.phone}</div>
            </div>
            <div style={{textAlign:'right'}}>
              <Badge color={pColor[l.pool]||'gray'}>{l.pool}</Badge>
              <div style={{marginTop:6}}><Badge color="green">{l.product_name}</Badge></div>
            </div>
          </div>
          <div style={{display:'flex',gap:20,fontSize:13,color:'var(--text2)',flexWrap:'wrap'}}>
            {l.caller_name&&<span>👤 Caller: <strong>{l.caller_name}</strong></span>}
            {l.last_disposition&&<span>Last: <Badge color="gray">{l.last_disposition}</Badge></span>}
            {l.last_remark&&<span style={{color:'var(--text3)',fontStyle:'italic'}}>"{l.last_remark}"</span>}
          </div>
          {l.followup_at&&<div style={{marginTop:8,fontSize:12,color:'var(--gold)'}}>📅 Follow Up: {l.followup_at?.slice(0,16)}</div>}
        </div>
      )))}
    </Card>
  );
}

// ─── PROFILE ──────────────────────────────────────────────────────────────
function Profile({ user }) {
  const [name,setName]=useState(user.name);
  const [email,setEmail]=useState(user.email);
  const [newPass,setNewPass]=useState('');
  const [note,setNote]=useState(()=>localStorage.getItem('pa_personal_note')||'');
  const [noteSaved,setNoteSaved]=useState(false);
  const [saving,setSaving]=useState(false);

  const saveProfile=async()=>{
    setSaving(true);
    const r=await api('users.php?action=update','PUT',{id:user.id,name,email,...(newPass?{password:newPass}:{})});
    if(r.status==='success'){toast('Profile updated!');setNewPass('');}else toast(r.message,'error');
    setSaving(false);
  };
  const saveNote=()=>{localStorage.setItem('pa_personal_note',note);setNoteSaved(true);setTimeout(()=>setNoteSaved(false),2000);};

  return(
    <div className="g2">
      <Card>
        <CT icon="👤">My Profile</CT>
        <div style={{textAlign:'center',marginBottom:24}}>
          <div style={{width:70,height:70,borderRadius:'50%',background:'linear-gradient(135deg,var(--green),var(--green2))',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:28,fontWeight:800,margin:'0 auto 12px'}}>{user.name[0].toUpperCase()}</div>
          <Badge color="green" style={{textTransform:'capitalize'}}>{user.role}</Badge>
        </div>
        <Inp label="Full Name" value={name} onChange={e=>setName(e.target.value)}/>
        <Inp label="Email Address" type="email" value={email} onChange={e=>setEmail(e.target.value)}/>
        <PasswordInput label="New Password (leave blank to keep current)" value={newPass} onChange={e=>setNewPass(e.target.value)}/>
        <Btn color="green" full onClick={saveProfile} disabled={saving}>{saving?'Saving...':'Save Profile'}</Btn>
      </Card>
      <Card>
        <CT icon="📝">Personal Notes</CT>
        <p style={{color:'var(--text3)',fontSize:13,marginBottom:14}}>Private notes — only stored on this device.</p>
        <TA value={note} onChange={e=>setNote(e.target.value)} rows={12} placeholder="Write your personal notes here..."/>
        <Btn color={noteSaved?'ghost':'green'} full onClick={saveNote} style={{marginTop:12}}>{noteSaved?'✅ Saved!':'💾 Save Notes'}</Btn>
      </Card>
    </div>
  );
}

// ─── MAIN APP ─────────────────────────────────────────────────────────────
export default function App() {
  const [user,setUser]=useState(null);
  const [page,setPage]=useState('dashboard');
  const [products,setProducts]=useState([]);
  const [notifCount,setNotifCount]=useState(0);
  const [loading,setLoading]=useState(true);

  useEffect(()=>{injectCSS();},[]);

  useEffect(()=>{
    const token=localStorage.getItem('pa_token');
    if(!token){setLoading(false);return;}
    api('auth.php?action=me').then(r=>{
      if(r.status==='success'){setUser(r.data);setPage(r.data.role==='caller'?'calling':'dashboard');}
      else localStorage.removeItem('pa_token');
      setLoading(false);
    });
  },[]);

  useEffect(()=>{
    if(!user)return;
    api('misc.php?type=products&action=list').then(r=>{if(r.status==='success')setProducts(r.data);});
    const checkNotif=async()=>{const r=await api('misc.php?type=messages&action=inbox');if(r.status==='success')setNotifCount(r.data.filter(m=>!m.is_read).length);};
    checkNotif();const t=setInterval(checkNotif,30000);return()=>clearInterval(t);
  },[user]);

  const handleLogin=u=>{setUser(u);setPage(u.role==='caller'?'calling':'dashboard');};
  const handleLogout=()=>{localStorage.removeItem('pa_token');setUser(null);setPage('dashboard');};

  const renderPage=()=>{
    if(!user)return null;
    switch(page){
      case 'dashboard': return user.role==='admin'?<AdminDashboard/>:<TLDashboard user={user}/>;
      case 'data': return <DataManagement user={user} products={products}/>;
      case 'assign': return <Assignment user={user} products={products}/>;
      case 'accounts': return <AdminAccounts/>;
      case 'attendance': return <AttendancePage user={user}/>;
      case 'products': return <AdminProducts/>;
      case 'blacklist': return <BlacklistPage user={user}/>;
      case 'reports': return <AdminReports products={products}/>;
      case 'settings': return <AdminSettings/>;
      case 'team': return <TLDashboard user={user}/>;
      case 'report': return <TLReport products={products}/>;
      case 'callers': return <TLCallers user={user}/>;
      case 'calling': return <CallingScreen user={user}/>;
      case 'punch': return <MyPunches/>;
      case 'myleads': return <MyLeads/>;
      case 'performance': return <Performance/>;
      case 'leaderboard': return <Leaderboard/>;
      case 'profile': return <Profile user={user}/>;
      case 'followups': return <FollowUps user={user}/>;
      case 'messages': return <Messages user={user}/>;
      case 'search': return <SearchLead/>;
      default: return <Empty title="Page not found"/>;
    }
  };

  if(loading)return(
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'var(--bg)'}}>
      <div style={{textAlign:'center'}}>
        <div className="spin" style={{width:40,height:40,margin:'0 auto 16px'}}/>
        <div style={{color:'var(--text3)'}}>Loading CRM...</div>
      </div>
    </div>
  );

  if(!user)return<LoginPage onLogin={handleLogin}/>;

  return(
    <div className="layout">
      <Sidebar user={user} page={page} onNav={setPage} onLogout={handleLogout} notifCount={notifCount}/>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="topbar-title">{PAGE_TITLE[page]||'Dashboard'}</div>
            <div className="topbar-sub">Welcome back, {user.name}</div>
          </div>
          <div className="topbar-right">
            {user.role==='caller'&&<TopPerformerFlash/>}
            {user.role==='caller'&&<FUFlasher onNav={setPage}/>}
            <div className="notif-bell" onClick={()=>setPage('messages')}>
              <span>🔔</span>
              {notifCount>0&&<span className="notif-dot"/>}
            </div>
            <img src={logo} alt="PA" style={{height:36,objectFit:'contain'}}/>
          </div>
        </div>
        <div className="page">{renderPage()}</div>
      </div>
      <div id="_toast" className="_toast"/>
    </div>
  );
}
